<template>
  <div class="landing-page-root" :class="{'light-mode': !darkMode}">

    <!-- Theme Toggle -->
    <button class="lp-theme-toggle" @click="toggleTheme" :title="darkMode?'Switch to Light':'Switch to Dark'">
      <i :class="darkMode?'mdi mdi-white-balance-sunny':'mdi mdi-moon-waning-crescent'" style="font-size:18px;"></i>
    </button>
    <div id="layout-wrapper">

      <!-- NAVBAR -->
      <nav class="landing-nav" :class="{ 'nav-scrolled': isScrolled }">
        <div class="container d-flex align-items-center justify-content-between py-2">
          <a href="javascript:void(0)" @click="$router.push('/')" class="nav-brand">
            <img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:38px;" />
          </a>
          <div class="d-none d-lg-flex align-items-center">
            <a href="#features" class="landing-nav-link" @click.prevent="scrollTo('features')">Features</a>
            <a href="#how-it-works" class="landing-nav-link" @click.prevent="scrollTo('how-it-works')">How It Works</a>
            <a href="#marketplace" class="landing-nav-link" @click.prevent="scrollTo('marketplace')">Marketplace</a>
            <a href="javascript:void(0)" class="landing-nav-link" @click="$router.push('/forum')">Community</a>
            <a href="#ecosystem" class="landing-nav-link" @click.prevent="scrollTo('ecosystem')">Ecosystem</a>
            <a v-if="plansVisible" href="#pricing" class="landing-nav-link" @click.prevent="scrollTo('pricing')">Pricing</a>
            <span class="landing-nav-divider"></span>
            <template v-if="isLoggedIn">
              <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="btn btn-sm btn-outline-warning me-2"><i class="mdi mdi-view-dashboard me-1"></i>Dashboard</a>
              <a href="javascript:void(0)" @click="$router.push('/marketplace')" class="btn btn-sm btn-outline-warning me-2"><i class="mdi mdi-storefront me-1"></i>Marketplace</a>
              <a v-if="isAdmin" href="javascript:void(0)" @click="$router.push('/admin')" class="btn btn-sm btn-outline-danger me-2"><i class="mdi mdi-shield-crown me-1"></i>Admin</a>
              <div class="landing-user-pill" @click="showUserDrop=!showUserDrop">
                <user-avatar :src="userAvatar" :name="userName" size="sm" />
                <span style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ userName }}</span>
                <i class="mdi mdi-chevron-down" style="color:var(--fm-s,#6B6356);font-size:14px;"></i>
              </div>
              <div v-if="showUserDrop" class="landing-user-drop">
                <a href="javascript:void(0)" @click="$router.push('/notifications');showUserDrop=false" class="landing-drop-item"><i class="mdi mdi-bell-outline me-2"></i>Notifications</a>
                <a href="javascript:void(0)" @click="$router.push('/messages');showUserDrop=false" class="landing-drop-item"><i class="mdi mdi-message-text-outline me-2"></i>Messages</a>
                <a href="javascript:void(0)" @click="$router.push('/my-listings');showUserDrop=false" class="landing-drop-item"><i class="mdi mdi-tag-multiple me-2"></i>My Listings</a>
                <a href="javascript:void(0)" @click="$router.push('/my-offers');showUserDrop=false" class="landing-drop-item"><i class="mdi mdi-handshake me-2"></i>My Offers</a>
                <a href="javascript:void(0)" @click="$router.push('/sell/create');showUserDrop=false" class="landing-drop-item"><i class="mdi mdi-plus-circle me-2"></i>New Listing</a>
                <div style="border-top:1px solid var(--fm-br,#2A2520);margin:6px 0;"></div>
                <a href="javascript:void(0)" @click="logout" class="landing-drop-item" style="color:#FF6B6B;"><i class="mdi mdi-logout me-2"></i>Sign Out</a>
              </div>
            </template>
            <template v-else>
              <a href="javascript:void(0)" @click="$router.push('/login')" class="btn btn-sm btn-outline-warning me-2">Sign In</a>
              <a href="javascript:void(0)" @click="$router.push('/register')" class="btn btn-sm btn-warning text-dark fw-bold">Get Started Free</a>
            </template>
          </div>
          <div class="d-flex align-items-center d-lg-none" style="gap:8px;">
            <!-- Avatar pill — one-tap to /me when signed in (no need to dig into the hamburger) -->
            <a v-if="isLoggedIn" href="javascript:void(0)" @click="$router.push('/me')" class="landing-mobile-avatar" :title="userName">
              <user-avatar :src="userAvatar" :name="userName" size="sm" />
            </a>
            <button class="lp-theme-toggle-mobile" @click="toggleTheme" :title="darkMode?'Switch to Light':'Switch to Dark'">
              <i :class="darkMode?'mdi mdi-white-balance-sunny':'mdi mdi-moon-waning-crescent'" style="font-size:18px;"></i>
            </button>
            <button class="btn btn-link p-0" style="color:var(--fm-h,#F5F0E8);" @click="mobileMenuOpen = !mobileMenuOpen">
              <i class="mdi mdi-menu" style="font-size:28px;" v-if="!mobileMenuOpen"></i>
              <i class="mdi mdi-close" style="font-size:28px;" v-else></i>
            </button>
          </div>
        </div>
        <div v-if="mobileMenuOpen" class="landing-mobile-menu d-lg-none">
          <a href="#features" class="landing-mobile-link" @click.prevent="scrollTo('features'); mobileMenuOpen=false">Features</a>
          <a href="#how-it-works" class="landing-mobile-link" @click.prevent="scrollTo('how-it-works'); mobileMenuOpen=false">How It Works</a>
          <a href="#marketplace" class="landing-mobile-link" @click.prevent="scrollTo('marketplace'); mobileMenuOpen=false">Marketplace</a>
          <a href="javascript:void(0)" class="landing-mobile-link" @click="$router.push('/forum'); mobileMenuOpen=false">Community</a>
          <a href="#ecosystem" class="landing-mobile-link" @click.prevent="scrollTo('ecosystem'); mobileMenuOpen=false">Ecosystem</a>
          <a v-if="plansVisible" href="#pricing" class="landing-mobile-link" @click.prevent="scrollTo('pricing'); mobileMenuOpen=false">Pricing</a>
          <div class="pt-3">
            <template v-if="isLoggedIn">
              <a href="javascript:void(0)" @click="$router.push('/dashboard');mobileMenuOpen=false" class="btn btn-outline-warning w-100 mb-2"><i class="mdi mdi-view-dashboard me-1"></i>Dashboard</a>
              <a href="javascript:void(0)" @click="$router.push('/marketplace');mobileMenuOpen=false" class="btn btn-outline-warning w-100 mb-2"><i class="mdi mdi-storefront me-1"></i>Marketplace</a>
              <a href="javascript:void(0)" @click="$router.push('/notifications');mobileMenuOpen=false" class="btn btn-outline-warning w-100 mb-2"><i class="mdi mdi-bell-outline me-1"></i>Notifications</a>
              <a href="javascript:void(0)" @click="$router.push('/messages');mobileMenuOpen=false" class="btn btn-outline-warning w-100 mb-2"><i class="mdi mdi-message-text-outline me-1"></i>Messages</a>
              <a v-if="isAdmin" href="javascript:void(0)" @click="$router.push('/admin');mobileMenuOpen=false" class="btn btn-outline-danger w-100 mb-2"><i class="mdi mdi-shield-crown me-1"></i>Admin</a>
              <a href="javascript:void(0)" @click="logout" class="btn btn-outline-danger w-100"><i class="mdi mdi-logout me-1"></i>Sign Out</a>
            </template>
            <template v-else>
              <a href="javascript:void(0)" @click="$router.push('/login')" class="btn btn-outline-warning w-100 mb-2">Sign In</a>
              <a href="javascript:void(0)" @click="$router.push('/register')" class="btn btn-warning text-dark fw-bold w-100">Get Started Free</a>
            </template>
          </div>
        </div>
      </nav>

      <!-- HERO -->
      <section class="landing-hero">
        <div class="container">
          <div class="row align-items-center" style="min-height:calc(100vh - 80px); padding-top:80px;">
            <div class="col-lg-7">
              <div class="mb-3">
                <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2"><i class="mdi mdi-shield-check me-1"></i> Trusted by 5,000+ Farmers Across East Africa</span>
              </div>
              <h1 class="landing-hero-title">Africa's Livestock Marketplace<br/><span style="color:#BFA164;">Buy, Sell &amp; Manage Farms</span></h1>
              <p class="landing-hero-subtitle mt-3">Flockr is the trusted livestock marketplace and farm management platform for farmers across Africa. Buy and sell cattle, goats, sheep, chickens, camels and pigs. Manage your farm records. Book vets online. Get agro-inputs, transport and insurance — all with escrow-protected payments via mobile money, bank transfer or card.</p>
              <div class="mt-4">
                <a href="javascript:void(0)" @click="$router.push('/register')" class="btn btn-warning text-dark fw-bold btn-lg me-2 mb-2"><i class="mdi mdi-rocket-launch me-1"></i> Start For Free</a>
                <a href="#how-it-works" class="btn btn-outline-light btn-lg mb-2" @click.prevent="scrollTo('how-it-works')"><i class="mdi mdi-play-circle me-1"></i> See How It Works</a>
              </div>
              <!-- Trust strip — icon-led positioning only (2026-07-29). Numeric claims were
                   removed because we can't yet verify "54 countries / 15K+ listings / 98% escrow".
                   Icons stay honest as the platform grows. -->
              <div class="d-flex align-items-center mt-5 flex-wrap">
                <div class="text-center px-3"><div class="fs-3" style="color:#BFA164;line-height:1;"><i class="mdi mdi-earth"></i></div><small class="text-muted">Pan-African</small></div>
                <div class="landing-stat-divider"></div>
                <div class="text-center px-3"><div class="fs-3" style="color:#BFA164;line-height:1;"><i class="mdi mdi-cow"></i></div><small class="text-muted">All Species</small></div>
                <div class="landing-stat-divider"></div>
                <div class="text-center px-3"><div class="fs-3" style="color:#BFA164;line-height:1;"><i class="mdi mdi-shield-check"></i></div><small class="text-muted">Secure Payments</small></div>
                <div class="landing-stat-divider"></div>
                <div class="text-center px-3"><div class="fs-3" style="color:#BFA164;line-height:1;"><i class="mdi mdi-stethoscope"></i></div><small class="text-muted">Vet Network</small></div>
              </div>
            </div>
            <div class="col-lg-5 d-none d-lg-block">
              <div class="text-center">
                <div class="landing-phone-mockup">
                  <div class="landing-phone-screen">
                    <div class="text-center pb-2 mb-2 landing-phone-header">
                      <img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:28px;opacity:0.9;" />
                    </div>
                    <div v-if="phoneListings.length === 0" class="text-center py-3">
                      <div class="spinner-border spinner-border-sm text-warning" role="status"></div>
                    </div>
                    <div v-for="(pl, pli) in phoneListings" :key="'ph-'+pli" class="d-flex align-items-center py-2 landing-phone-row">
                      <div class="landing-phone-icon"><i :class="getSpeciesIcon(pl.species_name)" style="font-size:32px;color:#BFA164;"></i></div>
                      <div class="ms-2">
                        <div class="fw-semibold landing-phone-title">{{ pl.title }}</div>
                        <div class="fw-bold" style="font-size:14px;color:#BFA164;">{{ (pl.currency || 'KES') }} {{ formatPrice(pl.price) }} <span style="font-size:10px;font-weight:500;color:var(--fm-s,#6B6356);">{{ perKgSub(pl) || priceUnitLabel(pl.price_unit) }}</span></div>
                        <div class="landing-phone-meta"><i class="mdi mdi-map-marker"></i> {{ pl.county_name || pl.location }}</div>
                      </div>
                    </div>
                    <div class="text-center mt-3">
                      <span class="btn btn-sm btn-warning text-dark fw-bold px-4" @click="$router.push('/marketplace')">Browse Marketplace</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- TRUSTED BY — hidden by default (Alex 2026-07-21). Admin flips
           landing_trust_strip_enabled=1 in Settings when the integrations are
           actually wired so the badges don't overpromise. -->
      <section v-if="showTrustStrip" class="py-4" style="background:var(--fm-bg2);border-bottom:1px solid var(--fm-br);">
        <div class="container">
          <p class="text-center text-muted mb-3" style="font-size:12px;letter-spacing:2px;font-weight:600;">INTEGRATED WITH PLATFORMS YOU ALREADY USE</p>
          <div class="d-flex justify-content-center align-items-center flex-wrap" style="gap:48px;">
            <div class="text-center text-muted"><i class="mdi mdi-cellphone-wireless d-block" style="font-size:32px;"></i><small class="fw-semibold">Mobile Money</small></div>
            <div class="text-center text-muted"><i class="mdi mdi-shield-check d-block" style="font-size:32px;"></i><small class="fw-semibold">Licensed Veterinary Boards</small></div>
            <div class="text-center text-muted"><i class="mdi mdi-truck-check d-block" style="font-size:32px;"></i><small class="fw-semibold">Compliant Transport</small></div>
            <div class="text-center text-muted"><i class="mdi mdi-certificate d-block" style="font-size:32px;"></i><small class="fw-semibold">Insurance Partners</small></div>
            <div class="text-center text-muted"><i class="mdi mdi-chart-line d-block" style="font-size:32px;"></i><small class="fw-semibold">Market Data</small></div>
          </div>
        </div>
      </section>

      <!-- CREDIT PASSPORT — every transaction builds credit history that unlocks financing -->
      <section class="py-5" style="background:var(--fm-bg1);border-top:1px solid #BFA164;border-bottom:1px solid #BFA164;">
        <div class="container">
          <div class="row align-items-center g-4">
            <div class="col-lg-7">
              <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2 mb-3" style="font-size:12px;letter-spacing:1.5px;">FLOCKR CREDIT PASSPORT</span>
              <h2 class="fw-bold" style="color:var(--fm-h);font-size:36px;line-height:1.2;">
                Every sale, every purchase, every vet visit — <span style="color:#BFA164;">builds your credit.</span>
              </h2>
              <p class="mt-3" style="color:var(--fm-m);font-size:16px;max-width:560px;">
                Africa's farmers have always been underserved by lenders because they have no formal credit history. Flockr changes that. Your on-platform transactions, KYC verification, farm records and community reputation combine into a portable <strong style="color:var(--fm-h);">Credit Passport</strong> — recognised by MFIs, SACCOs and banks.
              </p>
              <ul style="list-style:none;padding:0;color:var(--fm-h);font-size:14px;margin-top:16px;">
                <li class="mb-2"><i class="mdi mdi-check-circle" style="color:#BFA164;"></i> <strong>Score 0-1000</strong> · Bronze → Silver → Gold → Platinum → Diamond</li>
                <li class="mb-2"><i class="mdi mdi-check-circle" style="color:#BFA164;"></i> <strong>Downloadable statement</strong> (PDF) to attach to any loan application</li>
                <li class="mb-2"><i class="mdi mdi-check-circle" style="color:#BFA164;"></i> <strong>Shareable link</strong> — lenders see your live score, updated in real time</li>
                <li class="mb-2"><i class="mdi mdi-check-circle" style="color:#BFA164;"></i> <strong>You control access</strong> · revoke share links anytime</li>
              </ul>
              <div class="mt-4 d-flex gap-2 flex-wrap">
                <a href="javascript:void(0)" @click="$router.push(isLoggedIn ? '/credit-passport' : '/register')" class="btn btn-warning fw-bold">{{ isLoggedIn ? 'View My Credit Passport' : 'Start Building Your Credit' }} <i class="mdi mdi-arrow-right ms-1"></i></a>
                <a href="javascript:void(0)" @click="$router.push('/developers')" class="btn btn-outline-warning">For Lenders — API Access</a>
              </div>
            </div>
            <div class="col-lg-5">
              <div style="background:var(--fm-bg2);border:2px solid #BFA164;border-radius:16px;padding:24px;text-align:center;">
                <div style="font-size:11px;color:var(--fm-m);text-transform:uppercase;letter-spacing:1.5px;font-weight:600;">Flockr Credit Passport</div>
                <div style="font-size:64px;font-weight:800;color:#BFA164;font-family:'Courier New',monospace;line-height:1;margin:8px 0;">720</div>
                <div style="display:inline-block;background:#0ea5e9;color:#fff;padding:4px 14px;border-radius:20px;font-weight:700;font-size:13px;">
                  <i class="mdi mdi-medal me-1"></i>Platinum
                </div>
                <div style="color:var(--fm-m);font-size:12px;margin-top:12px;">Example: Rose Wanjiku, dairy farmer in Kiambu · 34 transactions · KYC verified · 4.8★ rating</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- FEATURES -->
      <section id="features" class="py-5" style="background:var(--fm-bg2);">
        <div class="container">
          <div class="text-center mb-5">
            <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">THE PLATFORM</span>
            <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">One Ecosystem. Everything Livestock.</h2>
            <p class="text-muted mx-auto" style="max-width:600px;">From the farm gate to the buyer's hand — Flockr covers every step of the livestock value chain</p>
          </div>
          <div class="row g-4">
            <div class="col-lg-4 col-md-6" v-for="(f, fi) in features" :key="fi">
              <div class="card h-100 landing-feature-card" :style="themeCardStyle">
                <div class="card-body p-4" :style="themeCardBodyStyle">
                  <div class="landing-feature-icon mb-3" :style="'background:' + f.bgColor"><i :class="f.icon + ' font-size-24'" :style="'color:' + f.iconColor"></i></div>
                  <h5 class="fw-bold mb-2 landing-theme-heading landing-text-17" :style="themeHeadingStyle">{{ f.title }}</h5>
                  <p class="mb-3 landing-theme-text landing-copy-14" :style="themeMutedStyle">{{ f.desc }}</p>
                  <div class="mb-3"><span class="landing-feature-tag" v-for="(tag, ti) in f.tags" :key="ti">{{ tag }}</span></div>
                  <a href="javascript:void(0)" @click="$router.push(f.link)" style="color:#BFA164;font-size:13px;font-weight:600;text-decoration:none;">{{ f.linkText }} <i class="mdi mdi-arrow-right"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- HOW IT WORKS -->
      <section id="how-it-works" class="py-5" style="background:var(--fm-bg1);">
        <div class="container">
          <div class="text-center mb-5">
            <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">SIMPLE PROCESS</span>
            <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">How Flockr Works</h2>
            <p class="text-muted">Whether you're buying, selling, or managing — we've made it simple</p>
          </div>
          <div class="mb-5" v-for="(flow, fi) in flows" :key="fi">
            <h4 class="mb-4" style="color:#BFA164;font-weight:700;"><i :class="flow.icon" class="me-2"></i> {{ flow.title }}</h4>
            <div class="row g-4">
              <div class="col-lg-3 col-md-6" v-for="(step, si) in flow.steps" :key="si">
                <div class="card h-100 landing-step-card" :style="themeCardStyle">
                  <div class="card-body p-4 text-center" :style="themeCardBodyStyle">
                    <div class="landing-step-number">{{ si + 1 }}</div>
                    <div class="my-3" style="font-size:36px;color:#BFA164;"><i :class="step.icon"></i></div>
                    <h6 class="fw-bold mb-2 landing-theme-heading" :style="themeHeadingStyle">{{ step.title }}</h6>
                    <p class="mb-0 landing-theme-text landing-copy-13" :style="themeMutedStyle">{{ step.desc }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- MARKETPLACE PREVIEW -->
      <section id="marketplace" class="py-5" style="background:var(--fm-bg2);">
        <div class="container">
          <div class="text-center mb-5">
            <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">LIVE MARKETPLACE</span>
            <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">What's Trading Right Now</h2>
            <p class="text-muted">Browse thousands of verified livestock listings across the region</p>
          </div>
          <div class="d-flex justify-content-center flex-wrap mb-4" style="gap:8px;">
            <button v-for="species in speciesList" :key="species.key" class="btn btn-sm landing-species-tab" :class="activeSpecies === species.key ? 'active' : ''" @click="filterBySpecies(species.key)">
              <i :class="species.icon" class="me-1"></i> {{ species.name }}
            </button>
          </div>

          <div v-if="loadingListings" class="text-center py-5">
            <div class="spinner-border text-warning" role="status"><span class="sr-only">Loading...</span></div>
            <p class="mt-2 text-muted">Loading listings...</p>
          </div>

          <div v-else-if="sampleListings.length === 0" class="text-center py-5">
            <i class="mdi mdi-store-off" style="font-size:48px;color:var(--fm-s);"></i>
            <p class="text-muted mt-2">No listings available yet. Be the first to sell!</p>
            <a href="javascript:void(0)" @click="$router.push('/sell/create')" class="btn btn-warning text-dark fw-bold"><i class="mdi mdi-plus me-1"></i> Create Listing</a>
          </div>

          <div v-else class="row g-4">
            <div class="col-lg-3 col-md-6" v-for="(item, index) in sampleListings" :key="index">
              <div class="card landing-listing-card" :style="themeCardStyle" @click="$router.push('/marketplace/listing/' + item.id)">
                <div class="landing-listing-img">
                  <img v-if="item.primary_photo" :src="photoUrl(item.primary_photo)" :alt="item.title" style="width:100%;height:100%;object-fit:cover;" />
                  <i v-else :class="getSpeciesIcon(item.species_name)" style="font-size:64px;color:rgba(191,161,100,0.3);"></i>
                  <div style="position:absolute;top:10px;left:10px;display:flex;gap:6px;">
                    <span v-if="item.seller_verified" class="badge bg-success bg-opacity-25 text-success" style="font-size:10px;" title="Seller KYC verified"><i class="mdi mdi-check-decagram"></i> Seller Verified</span><span v-if="Number(item.vet_verified) === 1" class="badge bg-info bg-opacity-25 text-info" style="font-size:10px;" title="Vet-verified animal"><i class="mdi mdi-stethoscope"></i> Vet Verified</span>
                  </div>
                  <button class="landing-save-btn"><i class="mdi mdi-heart-outline"></i></button>
                </div>
                <div class="card-body p-3" :style="themeCardBodyStyle">
                  <h6 class="fw-bold mb-1 landing-theme-heading landing-title-15" :style="themeHeadingStyle">{{ item.title }}</h6>
                  <div class="d-flex mb-1" style="gap:12px;font-size:12px;color:var(--fm-s);">
                    <span v-if="item.weight"><i class="mdi mdi-weight-kilogram"></i> {{ item.weight }} kg</span>
                    <span v-if="item.sex"><i class="mdi mdi-gender-male-female"></i> {{ item.sex }}</span>
                    <span v-if="item.age_text"><i class="mdi mdi-clock-outline"></i> {{ item.age_text }}</span>
                  </div>
                  <div class="mb-2" style="font-size:12px;color:var(--fm-m);"><i class="mdi mdi-map-marker"></i> {{ item.county_name || item.location }}</div>
                  <div class="d-flex justify-content-between align-items-center pt-2" style="border-top:1px solid var(--fm-br);">
                    <div class="fw-bold" style="font-size:18px;color:#BFA164;">{{ (item.currency || 'KES') }} {{ formatPrice(item.price) }} <span style="font-size:11px;font-weight:500;color:var(--fm-s,#6B6356);">{{ perKgSub(item) || priceUnitLabel(item.price_unit) }}</span></div>
                    <div class="d-flex align-items-center" style="gap:4px;font-size:12px;color:var(--fm-s);">
                      <div class="landing-seller-avatar">{{ getInitials(item.seller_name) }}</div>
                      <span>{{ item.seller_name }}</span>
                      <i class="mdi mdi-star text-warning" v-if="item.seller_rating"></i>
                      <span v-if="item.seller_rating">{{ item.seller_rating }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mt-5">
            <a href="javascript:void(0)" @click="$router.push('/marketplace')" class="btn btn-warning text-dark fw-bold btn-lg me-2"><i class="mdi mdi-store me-1"></i> Browse All Listings</a>
            <a href="javascript:void(0)" @click="$router.push('/sell/create')" class="btn btn-outline-warning btn-lg"><i class="mdi mdi-plus me-1"></i> Sell Your Livestock</a>
          </div>
        </div>
      </section>

      <!-- ECOSYSTEM -->
      <section id="ecosystem" class="py-5" style="background:var(--fm-bg1);">
        <div class="container">
          <div class="text-center mb-5">
            <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">COMPLETE PLATFORM</span>
            <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">The Flockr Ecosystem</h2>
            <p class="text-muted mx-auto" style="max-width:600px;">Every player in the livestock value chain, connected on one platform</p>
          </div>
          <div class="row g-4 justify-content-center">
            <div class="col-lg-4 col-md-6" v-for="(eco, ei) in ecoCards" :key="ei">
              <div class="card h-100 landing-eco-card" :style="themeCardStyle">
                <div class="card-body p-4" :style="themeCardBodyStyle">
                  <div style="font-size:40px;color:#BFA164;margin-bottom:12px;"><i :class="eco.icon"></i></div>
                  <h5 class="fw-bold mb-2 landing-theme-heading" :style="themeHeadingStyle">{{ eco.title }}</h5>
                  <p class="mb-3 landing-theme-text landing-copy-14" :style="themeMutedStyle">{{ eco.desc }}</p>
                  <ul class="list-unstyled mb-0">
                    <li v-for="(item, ii) in eco.items" :key="ii" class="d-flex align-items-center py-1 landing-theme-text" style="font-size:13px;gap:8px;">
                      <i class="mdi mdi-check" style="color:#BFA164;"></i> {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ANITRAC × FLOCKR — National Traceability. Gated by admin toggle
           (landing_anitrac_section_enabled) so we can hide it until the
           DVS partnership is formal enough to publicise. -->
      <section v-if="showAnitracSection" id="anitrac" class="py-5" style="background:linear-gradient(135deg,#0F1A14,#0A0A0A);border-top:1px solid #1E1E1E;border-bottom:1px solid #1E1E1E;">
        <div class="container">
          <div class="row align-items-center g-5">
            <div class="col-lg-7">
              <div class="d-flex align-items-center gap-2 mb-3">
                <span class="badge px-3 py-2" style="background:rgba(80,200,120,.15);color:#50C878;font-size:11px;letter-spacing:1.5px;font-weight:700;">
                  <i class="mdi mdi-shield-check me-1"></i>NATIONAL TRACEABILITY
                </span>
                <span class="badge px-2 py-2" style="background:rgba(191,161,100,.15);color:#BFA164;font-size:10px;letter-spacing:1px;font-weight:700;">
                  KENYA · 2020–2030
                </span>
              </div>
              <h2 class="fw-bold" style="font-size:34px;color:#F5F0E8;line-height:1.2;">
                Flockr is integrated with <span style="color:#50C878;">ANITRAC</span><br>
                <span style="font-size:22px;color:var(--fm-s,#A09888);font-weight:500;">Kenya's National Animal Identification &amp; Traceability System</span>
              </h2>
              <p class="mt-3" style="color:#D8CDB6;font-size:15px;line-height:1.7;">
                <strong style="color:#F5F0E8;">ANITRAC</strong> is the national framework launched by the
                <em>Directorate of Veterinary Services</em> under the Ministry of Agriculture, Livestock,
                Fisheries &amp; Cooperatives. Its goal: a unique digital identity for every animal in
                Kenya — feeding a central registry that supports disease control, theft recovery,
                export certification, and livestock-backed credit and insurance.
              </p>
              <p style="color:#D8CDB6;font-size:15px;line-height:1.7;">
                Every animal on Flockr can carry its ANITRAC tag. When the animal moves —
                sold, transported, slaughtered — Flockr captures the event automatically.
                That means the national registry stays current without anyone having to type
                anything twice.
              </p>

              <div class="row g-3 mt-2">
                <div class="col-md-6">
                  <div class="d-flex align-items-start gap-2">
                    <i class="mdi mdi-check-circle" style="color:#50C878;font-size:20px;margin-top:2px;"></i>
                    <div>
                      <div style="color:#F5F0E8;font-weight:700;font-size:14px;">Tags carried by every animal</div>
                      <div style="color:#A09888;font-size:12px;">Sellers enter their ANITRAC tag once on Create Animal — it shows on every listing as a trust badge.</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex align-items-start gap-2">
                    <i class="mdi mdi-check-circle" style="color:#50C878;font-size:20px;margin-top:2px;"></i>
                    <div>
                      <div style="color:#F5F0E8;font-weight:700;font-size:14px;">Movements captured automatically</div>
                      <div style="color:#A09888;font-size:12px;">Every sale, transport &amp; ownership transfer on Flockr is a record the national registry can consume in real time.</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex align-items-start gap-2">
                    <i class="mdi mdi-check-circle" style="color:#50C878;font-size:20px;margin-top:2px;"></i>
                    <div>
                      <div style="color:#F5F0E8;font-weight:700;font-size:14px;">Livestock as collateral, unlocked</div>
                      <div style="color:#A09888;font-size:12px;">Verified tag + on-platform ownership chain = insurers and lenders can underwrite an animal in seconds.</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex align-items-start gap-2">
                    <i class="mdi mdi-check-circle" style="color:#50C878;font-size:20px;margin-top:2px;"></i>
                    <div>
                      <div style="color:#F5F0E8;font-weight:700;font-size:14px;">Open developer integration</div>
                      <div style="color:#A09888;font-size:12px;">DVS, county vets and partner platforms can self-onboard at <code style="color:#BFA164;">flockr.africa/developers</code> — no bilateral spec, no waiting.</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4 d-flex flex-wrap gap-2">
                <a href="javascript:void(0)" @click="$router.push('/developers')" class="btn btn-success fw-bold" style="background:#50C878;border:none;">
                  <i class="mdi mdi-api me-1"></i> Open Developer Portal
                </a>
                <a href="javascript:void(0)" @click="$router.push('/developers/docs')" class="btn btn-outline-light fw-bold">
                  <i class="mdi mdi-book-open-page-variant me-1"></i> Integration Docs
                </a>
              </div>
            </div>

            <div class="col-lg-5">
              <div class="anitrac-card">
                <div class="anitrac-card-head">
                  <i class="mdi mdi-shield-check" style="color:#50C878;font-size:28px;"></i>
                  <div>
                    <div style="color:#F5F0E8;font-weight:800;font-size:15px;">Sample listing on Flockr</div>
                    <div style="color:#A09888;font-size:11px;">As a buyer sees it</div>
                  </div>
                </div>
                <div class="anitrac-card-body">
                  <div style="color:#F5F0E8;font-weight:700;font-size:15px;">Boran heifer · 36 months</div>
                  <div style="color:#A09888;font-size:12px;margin-bottom:10px;">Marsabit County · 285 kg</div>
                  <div class="d-flex gap-2 flex-wrap mb-3">
                    <span class="badge" style="background:rgba(80,200,120,.18);color:#50C878;font-weight:600;">
                      <i class="mdi mdi-shield-check me-1"></i>ANITRAC ✓
                    </span>
                    <span class="badge" style="background:rgba(80,200,120,.9);color:#fff;">
                      <i class="mdi mdi-barn me-1"></i>Farm Records
                    </span>
                    <span class="badge bg-success">
                      <i class="mdi mdi-check-decagram me-1"></i>Verified
                    </span>
                  </div>
                  <div style="color:#BFA164;font-weight:800;font-size:22px;">KES 81,225</div>
                  <div style="color:#6B6356;font-size:11px;margin-top:8px;font-family:'SF Mono',Menlo,monospace;">
                    ANITRAC: KE-CTL-2026-00041873
                  </div>
                </div>
                <div class="anitrac-card-foot">
                  Click <strong style="color:#50C878;">ANITRAC ✓</strong> to see the animal's full traceable history — owner chain, vaccinations, last vet visit, county movements.
                </div>
              </div>
            </div>
          </div>

          <!-- Government-facing trust strip -->
          <div class="anitrac-gov mt-5">
            <div class="row align-items-center g-3">
              <div class="col-md-1 text-center"><i class="mdi mdi-bank" style="font-size:36px;color:#BFA164;"></i></div>
              <div class="col-md-8">
                <div style="color:#F5F0E8;font-weight:700;font-size:14px;">A national partner for the State Department of Livestock</div>
                <div style="color:#A09888;font-size:12.5px;line-height:1.6;">
                  Flockr is purpose-built to be the field-level capture layer for ANITRAC. Smallholder pastoralists already transact on Flockr — every event needed by the national registry happens here first. We hand it on to DVS in real time, at zero data-entry cost to farmers, county vets or the Treasury.
                </div>
              </div>
              <div class="col-md-3 text-md-end">
                <a href="javascript:void(0)" @click="$router.push('/developers/docs')" style="color:#50C878;font-weight:700;text-decoration:none;font-size:13px;">
                  Read the integration spec <i class="mdi mdi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- M-PESA TRUST -->
      <section class="py-5" style="background:var(--fm-bg2);">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">SECURE PAYMENTS</span>
              <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">Your Money Is Held Safely</h2>
              <p class="mt-3 mb-4" style="font-size:16px;color:var(--fm-m);line-height:1.7;">Every transaction on Flockr is protected. When a buyer pays, the money is held securely until they confirm they've received the animal in the agreed condition. No more sending money and hoping for the best.</p>
              <div class="d-flex flex-column" style="gap:14px;">
                <div class="d-flex align-items-center" style="gap:12px;font-size:15px;color:var(--fm-h);" v-for="(tf, tfi) in trustFeatures" :key="tfi">
                  <i class="mdi mdi-check-circle font-size-20" style="color:#BFA164;"></i>
                  <span>{{ tf }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mt-4 mt-lg-0">
              <div class="card landing-escrow-card" :style="themeCardStyle">
                <div class="card-body p-4" :style="themeCardBodyStyle">
                  <div class="d-flex align-items-center justify-content-center mb-4">
                    <div class="landing-escrow-icon" style="background:rgba(80,165,241,.15);color:#50a5f1;"><i class="mdi mdi-account"></i></div>
                    <div style="width:60px;height:2px;background:var(--fm-br,#2A2520);"></div>
                    <div class="landing-escrow-icon landing-escrow-mid" style="background:rgba(191,161,100,.15);color:#BFA164;"><i class="mdi mdi-lock"></i></div>
                    <div style="width:60px;height:2px;background:var(--fm-br,#2A2520);"></div>
                    <div class="landing-escrow-icon" style="background:rgba(52,195,143,.15);color:#34c38f;"><i class="mdi mdi-account"></i></div>
                  </div>
                  <div class="d-flex justify-content-between mb-4 px-3" style="font-size:13px;font-weight:600;color:var(--fm-m);">
                    <span>Buyer Pays</span><span>Escrow Holds</span><span>Seller Receives</span>
                  </div>
                  <div class="d-flex flex-column px-3" style="gap:12px;">
                    <div class="d-flex align-items-center" style="gap:12px;font-size:14px;color:var(--fm-m);" v-for="(tl, tli) in escrowTimeline" :key="tli">
                      <div class="landing-tl-dot" :class="{ active: tl.active }"></div>
                      <span>{{ tl.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- PRICING -->
      <section v-if="plansVisible" id="pricing" class="py-5" style="background:var(--fm-bg1);">
        <div class="container">
          <div class="text-center mb-5">
            <span class="badge bg-warning bg-opacity-10 text-warning px-3 py-2" style="font-size:12px;letter-spacing:1.5px;">PRICING</span>
            <h2 class="fw-bold mt-3" style="font-size:36px;color:var(--fm-h);">Plans for every kind of livestock business</h2>
            <p class="text-muted">Marketplace listings are free on every plan. Farm management is free for up to 10 animals — upgrade when your herd grows to unlock bigger herds, boosts and AI tools.</p>
          </div>

          <div v-if="plansLoading" class="text-center py-5">
            <div class="spinner-border text-warning" role="status"></div>
          </div>

          <div v-else-if="plans.length" class="row g-3 justify-content-center align-items-stretch">
            <div v-for="plan in plans" :key="plan.id" class="col-12 col-md-6 col-lg-3 d-flex">
              <div class="card landing-pricing-card flex-fill" :class="{'landing-pricing-popular': plan.isPopular}" :style="themeCardStyle">
                <div v-if="plan.isPopular" class="landing-popular-badge">MOST POPULAR</div>
                <div class="card-body p-4 d-flex flex-column" :style="themeCardBodyStyle">
                  <div class="text-center mb-3">
                    <div class="fw-bold mb-1 landing-theme-text" style="font-size:14px;text-transform:uppercase;letter-spacing:1px;color:#BFA164;">{{ plan.name }}</div>
                    <div class="fw-bold landing-theme-heading mt-2" style="font-size:36px;line-height:1;">
                      <span v-if="plan.priceMonthly === 0">Free</span>
                      <span v-else>{{ plan.currency }} {{ formatPrice(plan.priceMonthly) }}<span class="landing-theme-muted" style="font-size:14px;font-weight:400;">/mo</span></span>
                    </div>
                    <div v-if="plan.priceAnnually && plan.priceMonthly > 0" class="landing-theme-muted mt-1" style="font-size:11px;">
                      or {{ plan.currency }} {{ formatPrice(plan.priceAnnually) }} / year ({{ annualSavingsLabel(plan) }})
                    </div>
                    <p class="landing-theme-muted mt-2" style="font-size:12px;min-height:32px;">{{ plan.description }}</p>
                  </div>

                  <ul class="list-unstyled mb-3 flex-fill" style="font-size:12px;">
                    <li v-for="(bullet, bi) in plan.bullets" :key="bi" class="d-flex align-items-start mb-2" style="gap:8px;">
                      <i :class="['mdi', bullet.icon || 'mdi-check']" style="color:#BFA164;font-size:16px;flex-shrink:0;"></i>
                      <span class="landing-theme-text">{{ bullet.label }}</span>
                    </li>
                  </ul>

                  <a v-if="mySubPlanId === plan.id" href="javascript:void(0)" class="btn fw-bold w-100 btn-success" style="pointer-events:none;">
                    <i class="mdi mdi-check-circle me-1"></i>Current plan
                  </a>
                  <a v-else href="javascript:void(0)" @click="choosePlan(plan)"
                     :class="['btn fw-bold w-100', plan.isPopular ? 'btn-warning text-dark' : 'btn-outline-warning']">
                    <i class="mdi mdi-arrow-right-circle me-1"></i>{{ plan.priceMonthly === 0 ? 'Start free' : 'Choose ' + plan.name }}
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- Fallback if plans fail to load -->
          <div v-else class="text-center text-muted py-4">Pricing details temporarily unavailable.</div>

          <!-- UPGRADE MODAL — real M-Pesa STK checkout for paid plans -->
          <div v-if="upgrade.open" style="position:fixed;inset:0;background:rgba(0,0,0,0.65);z-index:2000;display:flex;align-items:center;justify-content:center;padding:16px;" @click.self="closeUpgrade">
            <div style="background:var(--fm-bg2);border:1px solid var(--fm-br);border-radius:16px;max-width:420px;width:100%;padding:24px;position:relative;">
              <button @click="closeUpgrade" class="btn btn-sm" style="position:absolute;top:10px;right:10px;color:var(--fm-m);"><i class="mdi mdi-close" style="font-size:20px;"></i></button>

              <div v-if="upgrade.status !== 'success'">
                <div class="fw-bold mb-1" style="font-size:13px;letter-spacing:1px;text-transform:uppercase;color:#BFA164;">Upgrade to {{ upgrade.plan && upgrade.plan.name }}</div>
                <div class="fw-bold" style="font-size:28px;color:var(--fm-h);">
                  {{ upgrade.plan && upgrade.plan.currency }} {{ formatPrice(upgradePrice) }}
                  <span style="font-size:13px;font-weight:400;color:var(--fm-m);">/ {{ upgrade.cycle === 'annually' ? 'year' : 'month' }}</span>
                </div>

                <div class="d-flex mt-3" style="gap:8px;">
                  <button :class="['btn btn-sm flex-fill', upgrade.cycle === 'monthly' ? 'btn-warning text-dark fw-bold' : 'btn-outline-warning']" @click="upgrade.cycle = 'monthly'">Monthly</button>
                  <button v-if="upgrade.plan && upgrade.plan.priceAnnually" :class="['btn btn-sm flex-fill', upgrade.cycle === 'annually' ? 'btn-warning text-dark fw-bold' : 'btn-outline-warning']" @click="upgrade.cycle = 'annually'">Annual ({{ annualSavingsLabel(upgrade.plan) }})</button>
                </div>

                <label class="mt-3 mb-1" style="font-size:12px;color:var(--fm-m);">M-Pesa phone number</label>
                <input v-model="upgrade.phone" type="tel" class="form-control" placeholder="07XX XXX XXX" style="background:var(--fm-bg1);border:1px solid var(--fm-br);color:var(--fm-h);" :disabled="upgrade.sending || upgrade.status === 'polling'" />

                <div v-if="upgrade.status === 'polling'" class="mt-3 p-3 text-center" style="background:rgba(191,161,100,0.08);border:1px solid rgba(191,161,100,0.25);border-radius:10px;">
                  <div class="spinner-border spinner-border-sm text-warning mb-2" role="status"></div>
                  <div style="font-size:13px;color:var(--fm-h);">Check your phone and enter your M-Pesa PIN…</div>
                </div>
                <div v-if="upgrade.message && upgrade.status !== 'polling'" class="mt-3 p-2" :style="'border-radius:8px;font-size:12px;' + (upgrade.status === 'error' ? 'background:rgba(220,53,69,0.1);color:#dc6b6b;' : 'background:rgba(191,161,100,0.08);color:var(--fm-m);')">{{ upgrade.message }}</div>

                <button class="btn btn-warning text-dark fw-bold w-100 mt-3" :disabled="upgrade.sending || upgrade.status === 'polling'" @click="sendUpgradeStk">
                  <i class="mdi mdi-cellphone-wireless me-1"></i>{{ upgrade.sending ? 'Sending prompt…' : (upgrade.status === 'polling' ? 'Waiting for payment…' : 'Send M-Pesa prompt') }}
                </button>
                <button v-if="upgrade.status === 'error' || upgrade.status === 'timeout'" class="btn btn-outline-warning w-100 mt-2" @click="sendUpgradeStk"><i class="mdi mdi-refresh me-1"></i>Resend prompt</button>
              </div>

              <div v-else class="text-center py-3">
                <i class="mdi mdi-check-circle" style="font-size:56px;color:#34c38f;"></i>
                <div class="fw-bold mt-2" style="font-size:20px;color:var(--fm-h);">{{ upgrade.plan && upgrade.plan.name }} activated!</div>
                <div class="mt-1" style="font-size:13px;color:var(--fm-m);">{{ upgrade.message }}</div>
                <button class="btn btn-warning text-dark fw-bold w-100 mt-3" @click="closeUpgrade">Done</button>
              </div>
            </div>
          </div>

          <!-- Client issue 7: commission breakdown removed — fees are disclosed in Terms & Conditions only -->
          <div class="row mt-5 justify-content-center">
            <div class="col-lg-9">
              <div class="p-3" style="background:rgba(191,161,100,0.06);border:1px solid rgba(191,161,100,0.2);border-radius:10px;">
                <div class="d-flex" style="gap:10px;">
                  <i class="mdi mdi-shield-check" style="color:#BFA164;font-size:22px;flex-shrink:0;"></i>
                  <div>
                    <div class="landing-theme-heading fw-semibold" style="font-size:13px;">Selling is free. Listings are free.</div>
                    <div class="landing-theme-muted" style="font-size:12px;line-height:1.6;">List as many animals as you like on any plan. AI Vet, market reports and the forum are part of every tier. See our <a href="/terms" style="color:#BFA164;">Terms &amp; Conditions</a> for full fee details.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-5" style="background:var(--fm-bg2);border-top:1px solid var(--fm-br);">
        <div class="container text-center py-4">
          <h2 class="fw-bold" style="font-size:36px;color:var(--fm-h);">Ready to Transform Your Livestock Business?</h2>
          <p class="mt-2 mb-4" style="font-size:18px;color:var(--fm-m);">Join thousands of farmers, traders, and agribusinesses already using Flockr</p>
          <div>
            <a href="javascript:void(0)" @click="$router.push('/register')" class="btn btn-warning text-dark fw-bold btn-lg me-2 mb-2"><i class="mdi mdi-rocket-launch me-1"></i> Create Free Account</a>
            <a href="javascript:void(0)" @click="$router.push('/marketplace')" class="btn btn-outline-light btn-lg mb-2"><i class="mdi mdi-store me-1"></i> Browse Marketplace</a>
          </div>
          <p class="text-muted mt-3" style="font-size:13px;">No credit card required. Free forever plan available.</p>
        </div>
      </section>

      <!-- FOOTER -->
      <footer style="background:var(--fm-bg1);padding:60px 0 0;border-top:1px solid var(--fm-br);">
        <div class="container">
          <div class="row g-4">
            <div class="col-lg-4">
              <img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:45px;" class="mb-3" />
              <p style="font-size:14px;color:var(--fm-m);line-height:1.7;max-width:340px;">Africa's livestock ledger. Buy, sell, and manage livestock smarter with escrow-protected payments, vet telemedicine, GPS transport tracking, and insurance — all in one platform.</p>
              <!-- Seller Support — dynamic list pulled from support_contacts table; admins edit via Settings -->
              <div v-if="(supportContacts && supportContacts.length) || supportInfo.email || supportInfo.phone" style="margin-top:18px;padding:12px 14px;background:rgba(191,161,100,0.06);border:1px solid rgba(191,161,100,0.2);border-radius:10px;max-width:340px;">
                <div style="font-size:11px;font-weight:600;color:#BFA164;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:8px;"><i class="mdi mdi-headset me-1"></i>Seller Support</div>
                <!-- Per-person contacts (preferred) -->
                <div v-for="c in supportContacts" :key="c.id" style="margin-bottom:10px;">
                  <div style="font-size:13px;font-weight:600;color:var(--fm-h);line-height:1.3;">{{ c.name }}<span v-if="c.role" style="color:var(--fm-m);font-weight:400;"> — {{ c.role }}</span></div>
                  <div v-if="c.phone" style="font-size:12px;color:var(--fm-h);margin-top:2px;">
                    <i class="mdi mdi-phone-outline me-1" style="color:#BFA164;"></i>
                    <a :href="'tel:' + String(c.phone).replace(/[^+0-9]/g,'')" style="color:var(--fm-h);text-decoration:none;">{{ c.phone }}</a>
                  </div>
                  <div v-if="c.email" style="font-size:12px;color:var(--fm-h);margin-top:1px;">
                    <i class="mdi mdi-email-outline me-1" style="color:#BFA164;"></i>
                    <a :href="'mailto:' + c.email" style="color:var(--fm-h);text-decoration:none;">{{ c.email }}</a>
                  </div>
                </div>
                <!-- Fallback to legacy singular settings if no contact rows exist yet -->
                <template v-if="!(supportContacts && supportContacts.length)">
                  <div v-if="supportInfo.email" style="font-size:13px;color:var(--fm-h);margin-bottom:2px;">
                    <i class="mdi mdi-email-outline me-1" style="color:#BFA164;"></i>
                    <a :href="'mailto:' + supportInfo.email" style="color:var(--fm-h);text-decoration:none;">{{ supportInfo.email }}</a>
                  </div>
                  <div v-if="supportInfo.phone" style="font-size:13px;color:var(--fm-h);">
                    <i class="mdi mdi-phone-outline me-1" style="color:#BFA164;"></i>
                    <a :href="'tel:' + supportInfo.phone" style="color:var(--fm-h);text-decoration:none;">{{ supportInfo.phone }}</a>
                  </div>
                </template>
              </div>
              <div class="d-flex" style="gap:12px;margin-top:16px;">
                <a href="https://www.facebook.com/people/Flockr-Africa/61591340430828/" target="_blank" rel="noopener" title="Facebook — Flockr Africa" class="landing-social-icon"><i class="mdi mdi-facebook"></i></a>
                <a href="https://instagram.com/flockrafrica" target="_blank" rel="noopener" title="Instagram — @flockrafrica" class="landing-social-icon"><i class="mdi mdi-instagram"></i></a>
                <a href="https://twitter.com/flockrafrica" target="_blank" rel="noopener" title="X (Twitter) — @flockrafrica" class="landing-social-icon"><i class="mdi mdi-twitter"></i></a>
                <a href="https://www.tiktok.com/@flockr.africa" target="_blank" rel="noopener" title="TikTok — @flockr.africa" class="landing-social-icon">
                  <svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor" aria-label="TikTok"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/></svg>
                </a>
                <a href="https://wa.me/254706466780" target="_blank" rel="noopener" title="WhatsApp — Flockr Africa" class="landing-social-icon"><i class="mdi mdi-whatsapp"></i></a>
              </div>
            </div>
            <div class="col-lg-2 col-6" v-for="(col, ci) in footerColumns" :key="ci">
              <h6 class="fw-bold mb-3 text-uppercase" style="font-size:14px;color:var(--fm-h);letter-spacing:.5px;">{{ col.heading }}</h6>
              <ul class="list-unstyled">
                <li v-for="(link, li) in col.links" :key="li" v-show="!(link.url === '#pricing' && !plansVisible)" class="mb-2">
                  <a href="javascript:void(0)" @click="$router.push(link.url)" style="color:var(--fm-m);text-decoration:none;font-size:14px;">{{ link.text }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="text-center py-3 mt-4" style="border-top:1px solid var(--fm-br);">
            <p class="mb-0 text-muted" style="font-size:13px;">&copy; {{ currentYear }} Flockr. Africa's Livestock Ledger. All rights reserved.</p>
            <p class="mb-0 mt-3" style="font-size:13px;color:var(--fm-m);display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap;">
              <span>Designed &amp; built by</span>
              <a href="https://www.craftsilicon.com" target="_blank" rel="noopener" title="Craft Silicon — Thinking. Crafting. Transforming." style="display:inline-flex;align-items:center;gap:6px;color:#1E3A8A;text-decoration:none;font-weight:600;">
                <img src="/assets/images/craft-silicon-logo.png" alt="Craft Silicon" style="height:22px;vertical-align:middle;" />
                <span class="visually-hidden">Craft Silicon</span>
                <i class="mdi mdi-open-in-new" style="font-size:12px;color:var(--fm-m);"></i>
              </a>
            </p>
            <p class="mb-0 text-muted mt-2" style="font-size:13px;">In partnership with <a href="https://www.ranchexperts.co.ke/" target="_blank" rel="noopener" style="color:#BFA164;text-decoration:none;font-weight:600;">Ranch Experts <i class="mdi mdi-open-in-new" style="font-size:12px;"></i></a></p>
          </div>
        </div>
      </footer>

    </div>
    <div class="rightbar-overlay"></div>

    <!-- Sticky bottom signup CTA — only for not-logged-in visitors who've scrolled past the hero -->
    <transition name="landing-cta-fade">
      <div v-if="showSignupCta" class="landing-signup-cta" role="region" aria-label="Sign up free">
        <div class="landing-signup-cta-inner">
          <div class="landing-signup-cta-msg">
            <strong>Join Flockr free</strong>
            <span class="d-none d-sm-inline"> — list animals, get vet help, manage your farm.</span>
          </div>
          <div class="landing-signup-cta-actions">
            <a href="javascript:void(0)" @click="dismissSignupCta(); $router.push('/login')" class="landing-signup-cta-secondary">I have an account</a>
            <a href="javascript:void(0)" @click="$router.push('/register')" class="landing-signup-cta-primary">Sign up free</a>
            <button class="landing-signup-cta-x" @click="dismissSignupCta" title="Dismiss"><i class="mdi mdi-close"></i></button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable */
import { executeJson, flocker, uploads } from "@/api";
import UserAvatar from "@/components/flockr-users/UserAvatar.vue";

export default {
  name: "LandingPage",
  components: { UserAvatar },
  data() {
    return {
      plansVisible: true,
      showTrustStrip: false,  // gated by getPublicSettings.landing_trust_strip_enabled
      showAnitracSection: false,  // gated by getPublicSettings.landing_anitrac_section_enabled
      darkMode: (document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || 'light') !== 'light',
      themeObserver: null,
      isScrolled: false,
      mobileMenuOpen: false,
      showUserDrop: false,
      isLoggedIn: false,
      // Sticky bottom signup CTA — appears after the visitor has shown engagement
      // (scrolled past the hero), can be dismissed and remembered via localStorage.
      hasScrolledPastHero: false,
      signupCtaDismissed: localStorage.getItem('flockr_landing_cta_dismissed') === '1',
      userName: '',
      userInitials: '',
      userAvatar: '',
      activeSpecies: 'all',

      // API-driven data
      speciesList: [],
      sampleListings: [],
      phoneListings: [],
      loadingListings: false,
      loadingSpecies: false,

      // Static content (UI text, not database data)
      features: [
        { title: 'Livestock Marketplace', desc: 'Buy and sell cattle, goats, sheep, poultry, pigs, camels, and more. Individual animals or batches. Verified sellers with escrow-protected payments.', icon: 'mdi mdi-store', bgColor: 'rgba(191,161,100,.12)', iconColor: '#BFA164', tags: ['Individual & Batch', 'Escrow Payments', 'Price Negotiation'], link: '/marketplace', linkText: 'Explore Marketplace' },
        { title: 'Farm Management', desc: 'Track every animal — weight, health, vaccinations, deworming, breeding, milk yields, egg production. Your complete digital farm record.', icon: 'mdi mdi-barn', bgColor: 'rgba(52,195,143,.12)', iconColor: '#34c38f', tags: ['Animal Profiles', 'Health Tracking', 'Production Records'], link: '/farm', linkText: 'Manage My Farm' },
        { title: 'Vet Services & Telemedicine', desc: 'Connect with KVB-registered vets for farm visits, video consultations, and emergency care. Plus AI-powered symptom checker for quick guidance.', icon: 'mdi mdi-stethoscope', bgColor: 'rgba(80,165,241,.12)', iconColor: '#50a5f1', tags: ['Telemedicine', 'AI Symptom Check', 'Emergency 24/7'], link: '/vets', linkText: 'Find a Vet' },
        { title: 'Transport & Logistics', desc: 'Book vetted, road-compliant livestock transporters with GPS tracking, animal welfare checklists, and transit insurance. Know where your animals are in real-time.', icon: 'mdi mdi-truck-fast', bgColor: 'rgba(241,180,76,.12)', iconColor: '#f1b44c', tags: ['GPS Tracking', 'Vetted Transporters', 'Welfare Checklists'], link: '/transport', linkText: 'Book Transport' },
        { title: 'Insurance & Finance', desc: 'Protect your investment and access working capital — livestock, transit, and theft insurance, plus farmer-friendly loans and asset financing from trusted providers across Africa. Instant policy issuance and digital claims processing.', icon: 'mdi mdi-shield-half-full', bgColor: 'rgba(155,89,182,.12)', iconColor: '#9b59b6', tags: ['Livestock Cover', 'Asset Financing', 'Working Capital'], link: '/insurance', linkText: 'Get Covered' },
        { title: 'Market Intelligence', desc: 'Real-time market prices by country, breed, and species. AI-powered price recommendations, market reports, and trend analysis to sell at the right time.', icon: 'mdi mdi-chart-areaspline', bgColor: 'rgba(26,188,156,.12)', iconColor: '#1abc9c', tags: ['Live Prices', 'AI Pricing', 'Country Reports'], link: '/market', linkText: 'View Market Data' },
        { title: 'Bulk Buying & Aggregation', desc: 'Post buy requests for bulk orders. Aggregators can build trusted supplier networks, compare offers, and coordinate large-scale procurement effortlessly.', icon: 'mdi mdi-account-group', bgColor: 'rgba(231,76,60,.12)', iconColor: '#e74c3c', tags: ['Buy Requests', 'Supplier Networks', 'Bulk Orders'], link: '/marketplace/buy-requests', linkText: 'Post Buy Request' },
        { title: 'Agro-Input Shop', desc: 'Shop for animal feeds, supplements, veterinary drugs, farming equipment, and supplies. Delivered to your farm or pick up from nearby stockists.', icon: 'mdi mdi-package-variant-closed', bgColor: 'rgba(241,196,15,.12)', iconColor: '#f1c40f', tags: ['Feeds & Supplements', 'Vet Drugs', 'Equipment'], link: '/shop', linkText: 'Shop Now' },
        { title: 'Community & Learning', desc: 'Join farmer forums, read expert articles in English and Swahili, ask vets questions, and learn best practices from thousands of farmers across the region.', icon: 'mdi mdi-forum', bgColor: 'rgba(232,67,147,.12)', iconColor: '#e84393', tags: ['Farmer Forums', 'Expert Articles', 'EN & SW'], link: '/forum', linkText: 'Join Community' }
      ],

      flows: [
        { title: 'Buying Livestock', icon: 'mdi mdi-cart', steps: [
            { icon: 'mdi mdi-magnify', title: 'Search & Filter', desc: 'Browse listings by species, breed, country, price range. View photos, health records, and seller ratings.' },
            { icon: 'mdi mdi-handshake', title: 'Negotiate & Order', desc: 'Make offers, negotiate price directly with sellers. Place order with quantity and delivery preference.' },
            { icon: 'mdi mdi-cellphone-wireless', title: 'Pay Your Way', desc: 'Pay securely via mobile money, bank transfer or card. Funds are held in escrow — the seller gets paid only after you confirm delivery and quality.' },
            { icon: 'mdi mdi-truck-delivery', title: 'Receive & Inspect', desc: 'Collect or get delivery via Flockr Transport. Inspect for 48 hours. Approve to release payment, or raise a dispute.' }
          ]},
        { title: 'Selling Livestock', icon: 'mdi mdi-tag-plus', steps: [
            { icon: 'mdi mdi-camera-plus', title: 'List Your Animal', desc: 'Upload photos, set your price, add health records. List individual animals or full batches.' },
            { icon: 'mdi mdi-bell-ring', title: 'Receive Offers', desc: 'Get notified when buyers make offers. Negotiate, counter-offer, or accept. All within the platform.' },
            { icon: 'mdi mdi-package-variant', title: 'Hand Over', desc: 'Arrange pickup or book a Flockr transporter. Upload handover photos. Movement permit handled digitally.' },
            { icon: 'mdi mdi-wallet-plus', title: 'Get Paid', desc: 'Escrow releases automatically after buyer confirms. Withdraw to mobile money or bank instantly. No more bounced cheques.' }
          ]}
      ],

      ecoCards: [
        { icon: 'mdi mdi-account-cowboy-hat', title: 'Farmers', desc: 'List animals, manage your farm digitally, track health records, vaccinations, breeding, production — and sell directly to verified buyers.', items: ['Farm dashboard & analytics', 'Animal profiles with QR codes', 'Vaccination & deworming alerts', 'Direct marketplace access'] },
        { icon: 'mdi mdi-cart', title: 'Buyers & Traders', desc: 'Search verified listings, negotiate prices, pay via mobile money, bank or card with escrow protection, and arrange transport — all from your phone.', items: ['Advanced search & filters', 'Escrow-protected payments', '48-hour inspection window', 'Bulk buy requests'] },
        { icon: 'mdi mdi-stethoscope', title: 'Veterinarians', desc: 'Reach more farmers through telemedicine, manage appointments, build your practice, and offer wellness subscription plans.', items: ['Video consultations', 'Digital prescriptions', 'Appointment management', 'Wellness program subscriptions'] },
        { icon: 'mdi mdi-truck', title: 'Transporters', desc: 'Get booked by buyers and sellers, manage your fleet, track trips with GPS, and earn consistently through the platform.', items: ['Trip management dashboard', 'GPS live tracking', 'Welfare checklists', 'Fleet & vehicle management'] },
        { icon: 'mdi mdi-shield-check', title: 'Insurance Partners', desc: 'Offer livestock, transit, and index-based insurance products to thousands of farmers. Digital policy issuance and claims management.', items: ['Instant policy issuance', 'Digital claims with evidence', 'Multiple coverage types', 'Partner dashboard'] },
        { icon: 'mdi mdi-package-variant', title: 'Input Suppliers', desc: 'Sell feeds, drugs, equipment, and supplements directly to farmers. Manage inventory, orders, and delivery through the Flockr product marketplace.', items: ['Product catalogue', 'Order management', 'Inventory tracking', 'Seller analytics'] }
      ],

      trustFeatures: [
        'Pay in one tap — simple and instant',
        'Funds held safely until buyer confirms delivery',
        '48-hour inspection window after delivery',
        'Dispute resolution with dedicated mediators',
        'Seller receives funds directly to their account',
        'Complete transaction history and audit trail'
      ],

      escrowTimeline: [
        { label: 'Order Placed', active: true },
        { label: 'Payment Received', active: true },
        { label: 'Animal Dispatched', active: true },
        { label: 'Buyer Inspects', active: false },
        { label: 'Funds Released', active: false }
      ],

      // Subscription plans — fetched live from the API so admins can edit pricing/features in the DB without code changes
      plans: [],
      plansLoading: true,
      // Plan upgrade — real STK checkout (logged-in users) instead of dumping to /register
      mySubPlanId: null,
      upgrade: { open: false, plan: null, cycle: 'monthly', phone: '', sending: false, status: '', message: '', stkRequestId: '', pollTimer: null, pollCount: 0 },
      // Support contact — fetched live so admins can change email/phone via the Settings tab
      supportInfo: { email: '', phone: '' },
      supportContacts: [],

      footerColumns: [
        { heading: 'Marketplace', links: [{ text: 'Browse Listings', url: '/marketplace' }, { text: 'Sell Livestock', url: '/sell/create' }, { text: 'Buy Requests', url: '/marketplace/buy-requests' }, { text: 'Corporate Buyers', url: '/corporate/profile' }, { text: 'Agro-Inputs', url: '/shop' }, { text: 'Market Prices', url: '/market' }] },
        { heading: 'Services', links: [{ text: 'Find a Vet', url: '/vets' }, { text: 'Transport', url: '/transport' }, { text: 'Insurance & Finance', url: '/insurance' }, { text: 'AI Symptom Check', url: '/vet/ai-check' }, { text: 'Farm Management', url: '/farm' }] },
        { heading: 'Community', links: [{ text: 'Farmer Forum', url: '/forum' }, { text: 'Learning Hub', url: '/learn' }, { text: 'Market Reports', url: '/market' }, { text: 'Pricing', url: '#pricing' }, { text: 'Help Center', url: '/forum' }] },
        { heading: 'Company', links: [{ text: 'About Us', url: '#' }, { text: 'Careers', url: '#' }, { text: 'Blog', url: '#' }, { text: 'Privacy Policy', url: '#' }, { text: 'Terms of Service', url: '#' }] },
        { heading: 'Developers', links: [{ text: 'Developer Portal', url: '/developers' }, { text: 'API Documentation', url: '/developers/docs' }, { text: 'Webhook Events', url: '/developers/docs#events' }] }
      ]
    };
  },
  computed: {
    currentYear() { return new Date().getFullYear(); },
    showSignupCta() {
      // Visible only when: not logged in, on the landing route, visitor has scrolled past
      // the hero (engagement signal), and they haven't dismissed it previously.
      return !this.isLoggedIn && this.hasScrolledPastHero && !this.signupCtaDismissed;
    },
    themeCardStyle() {
      return this.darkMode
          ? 'background:#141414 !important; background-color:#141414 !important; border:1px solid #1E1E1E !important;'
          : 'background:#FFFFFF !important; background-color:#FFFFFF !important; border:1px solid #E8E2DA !important;';
    },
    themeCardBodyStyle() {
      return this.darkMode
          ? 'background:#141414 !important; background-color:#141414 !important; color:#F5F0E8 !important;'
          : 'background:#FFFFFF !important; background-color:#FFFFFF !important; color:#1A1A1A !important;';
    },
    themeHeadingStyle() {
      return this.darkMode
          ? 'color:#F5F0E8 !important;'
          : 'color:#1A1A1A !important;';
    },
    themeMutedStyle() {
      return this.darkMode
          ? 'color:#A09888 !important;'
          : 'color:#555555 !important;';
    },
    upgradePrice() {
      if (!this.upgrade.plan) return 0;
      return this.upgrade.cycle === 'annually' && this.upgrade.plan.priceAnnually
          ? this.upgrade.plan.priceAnnually
          : this.upgrade.plan.priceMonthly;
    }
  },
  mounted() {
    this.syncThemeState();
    window.__flockrSetTheme(this.darkMode ? 'dark' : 'light');
    this.setupThemeObserver();
    window.addEventListener('scroll', this.handleScroll);
    this.checkLoginState();
    this.initializePage();
    this.loadPublicSettings();
    this.fetchPlans();
    this.fetchMySubscription();
    // SEO — Organization JSON-LD on the landing page
    if (this.$updateHead) {
      this.$updateHead({
        title: 'Flockr · Africa\'s Livestock Marketplace, Farm Management & Vet Services',
        description: 'Flockr connects farmers, buyers, vets and transporters across Africa. Buy and sell livestock, manage your farm, and book vets — all with escrow protection.',
        jsonLd: {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          'name': 'Flockr',
          'url': 'https://flockr.africa',
          'logo': 'https://flockr.africa/assets/images/flockr_logo.png',
          'description': 'Pan-African livestock marketplace, farm management platform, and veterinary services network.',
          'sameAs': [
            'https://www.facebook.com/people/Flockr-Africa/61591340430828/',
            'https://twitter.com/flockrafrica',
            'https://instagram.com/flockrafrica',
            'https://www.tiktok.com/@flockr.africa'
          ],
          'address': { '@type': 'PostalAddress', 'addressCountry': 'KE', 'addressLocality': 'Nairobi' },
          'areaServed': ['KE','TZ','UG','RW','ET','NG','ZA'],
          'contactPoint': { '@type': 'ContactPoint', 'contactType': 'customer service', 'email': 'support@flockr.africa' }
        }
      });
    }
  },
  beforeUnmount() {
    if (this.upgrade.pollTimer) { clearInterval(this.upgrade.pollTimer); this.upgrade.pollTimer = null; }
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('storage', this.syncThemeState);
    if (this.themeObserver) {
      this.themeObserver.disconnect();
      this.themeObserver = null;
    }
  },
  methods: {
    async loadPublicSettings() {
      try {
        const r = await executeJson({ function: 'getPublicSettings' }, flocker);
        if (r.data && r.data.success && r.data.data && r.data.data.settings) {
          this.plansVisible = String(r.data.data.settings.plans_visible) !== 'false';
          this.showTrustStrip = String(r.data.data.settings.landing_trust_strip_enabled) === '1';
          this.showAnitracSection = String(r.data.data.settings.landing_anitrac_section_enabled) === '1';
        }
      } catch (e) { /* silent — default to hidden */ }
    },
    async fetchPlans() {
      try {
        const response = await executeJson({ function: 'getSubscriptionPlans' }, flocker);
        if (response.data && response.data.success) {
          this.plans = (response.data.data && response.data.data.plans) || [];
        }
      } catch (e) { /* keep silent on landing page — fallback message renders */ }
      this.plansLoading = false;

      // Fetch support contact info in parallel (no blocking)
      try {
        const sr = await executeJson({ function: 'getSupportInfo' }, flocker);
        if (sr.data && sr.data.success && sr.data.data) this.supportInfo = sr.data.data;
        // New: per-person support contacts (table-backed, admin editable)
        try {
          const cr = await executeJson({ function: 'getSupportContacts' }, flocker);
          if (cr.data && cr.data.success && cr.data.data && Array.isArray(cr.data.data.contacts)) {
            this.supportContacts = cr.data.data.contacts;
          }
        } catch (e) { /* ignore — landing still renders with legacy supportInfo fallback */ }
      } catch (e) { /* keep silent */ }
    },
    formatPrice(v) {
      if (v === null || v === undefined) return '';
      return Number(v).toLocaleString();
    },
    annualSavingsLabel(plan) {
      if (!plan.priceAnnually || !plan.priceMonthly) return '';
      const twelve = plan.priceMonthly * 12;
      if (plan.priceAnnually >= twelve) return 'save annually';
      const pct = Math.round(((twelve - plan.priceAnnually) / twelve) * 100);
      return 'save ' + pct + '%';
    },
    syncThemeState() {
      const docTheme = document.documentElement.getAttribute('data-theme');
      const storedTheme = localStorage.getItem('flockr_theme');
      const resolvedTheme = docTheme || storedTheme || 'light';
      this.darkMode = resolvedTheme !== 'light';
    },

    setupThemeObserver() {
      this.themeObserver = new MutationObserver(() => {
        this.syncThemeState();
      });
      this.themeObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-theme']
      });
      window.addEventListener('storage', this.syncThemeState);
    },

    toggleTheme() {
      this.darkMode = !this.darkMode;
      const theme = this.darkMode ? 'dark' : 'light';
      localStorage.setItem('flockr_theme', theme);
      window.__flockrSetTheme(theme);
    },

    photoUrl(p) {
      if (!p) return '';
      if (p.startsWith && p.startsWith('http')) return p;
      return uploads + String(p).replace('uploads/', '');
    },

    handleScroll() {
      var y = window.scrollY;
      this.isScrolled = y > 50;
      if (!this.hasScrolledPastHero && y > 300) this.hasScrolledPastHero = true;
    },
    dismissSignupCta() {
      this.signupCtaDismissed = true;
      try { localStorage.setItem('flockr_landing_cta_dismissed', '1'); } catch(e) { /* silent */ }
    },
    scrollTo(id) { var el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); },

    // ============ PLAN UPGRADE (STK) ============

    async fetchMySubscription() {
      var uid = sessionStorage.getItem('userId');
      if (!uid) return;
      try {
        const r = await executeJson({ function: 'getMySubscription', userId: uid }, flocker);
        if (r.data && r.data.success && r.data.data) {
          this.mySubPlanId = r.data.data.subscription
            ? r.data.data.subscription.plan_id
            : (r.data.data.plan ? r.data.data.plan.id : null);
        }
      } catch (e) { /* silent — badge is cosmetic */ }
    },

    choosePlan(plan) {
      var uid = sessionStorage.getItem('userId');
      if (!uid) { this.$router.push('/register'); return; }
      if (plan.priceMonthly === 0) { this.downgradeToFree(plan); return; }
      if (this.upgrade.pollTimer) { clearInterval(this.upgrade.pollTimer); this.upgrade.pollTimer = null; }
      this.upgrade = { open: true, plan: plan, cycle: 'monthly', phone: sessionStorage.getItem('userPhone') || '', sending: false, status: '', message: '', stkRequestId: '', pollTimer: null, pollCount: 0 };
    },

    async downgradeToFree(plan) {
      var uid = sessionStorage.getItem('userId');
      try {
        const r = await executeJson({ function: 'subscribeToPlan', userId: uid, planId: plan.id }, flocker);
        if (r.data && r.data.success) { this.mySubPlanId = plan.id; }
      } catch (e) { /* silent */ }
    },

    async sendUpgradeStk() {
      var uid = sessionStorage.getItem('userId');
      if (!uid || !this.upgrade.plan) return;
      this.upgrade.sending = true; this.upgrade.status = ''; this.upgrade.message = '';
      try {
        const r = await executeJson({
          function: 'subscribeToPlan', userId: uid, planId: this.upgrade.plan.id,
          billingCycle: this.upgrade.cycle, phone: this.upgrade.phone
        }, flocker);
        if (r.data && r.data.success && r.data.data && r.data.data.stkRequestId) {
          this.upgrade.stkRequestId = r.data.data.stkRequestId;
          this.upgrade.status = 'polling'; this.upgrade.pollCount = 0;
          this.upgrade.pollTimer = setInterval(this.pollUpgradeStatus, 3000);
        } else {
          this.upgrade.status = 'error';
          this.upgrade.message = (r.data && r.data.message) || 'Could not send the M-Pesa prompt. Try again.';
        }
      } catch (e) {
        this.upgrade.status = 'error';
        this.upgrade.message = 'Network error — please try again.';
      }
      this.upgrade.sending = false;
    },

    async pollUpgradeStatus() {
      this.upgrade.pollCount++;
      if (this.upgrade.pollCount > 40) { // ~2 minutes
        clearInterval(this.upgrade.pollTimer); this.upgrade.pollTimer = null;
        this.upgrade.status = 'timeout';
        this.upgrade.message = 'No response from M-Pesa. If you entered your PIN, your plan will activate shortly — otherwise resend the prompt.';
        return;
      }
      try {
        const r = await executeJson({ function: 'checkStkStatus', stkRequestId: this.upgrade.stkRequestId }, flocker);
        var st = r.data && r.data.data && r.data.data.status;
        if (st === 'success') {
          clearInterval(this.upgrade.pollTimer); this.upgrade.pollTimer = null;
          this.upgrade.status = 'success';
          this.upgrade.message = 'Payment received — your new limits apply immediately.';
          this.mySubPlanId = this.upgrade.plan.id;
        } else if (st === 'cancelled' || st === 'failed' || st === 'timeout') {
          clearInterval(this.upgrade.pollTimer); this.upgrade.pollTimer = null;
          this.upgrade.status = 'error';
          this.upgrade.message = st === 'cancelled' ? 'You cancelled the M-Pesa prompt.' : ((r.data && r.data.data && r.data.data.resultDesc) || 'Payment failed. Try again.');
        }
      } catch (e) { /* keep polling */ }
    },

    closeUpgrade() {
      if (this.upgrade.pollTimer) { clearInterval(this.upgrade.pollTimer); this.upgrade.pollTimer = null; }
      this.upgrade.open = false;
    },

    checkLoginState() {
      var loggedIn = sessionStorage.getItem('isLoggedIn');
      if (loggedIn) {
        this.isLoggedIn = true;
        var name = sessionStorage.getItem('userName') || '';
        this.userName = name;
        this.userAvatar = sessionStorage.getItem('userAvatar') || '';
        var parts = name.split(' ');
        this.userInitials = parts.map(function(p) { return p.charAt(0).toUpperCase(); }).join('').substring(0, 2);
      }
    },

    logout() {
      sessionStorage.clear();
      localStorage.removeItem('authToken');
      this.isLoggedIn = false;
      this.userName = '';
      this.userInitials = '';
      this.showUserDrop = false;
      this.mobileMenuOpen = false;
      this.$router.push('/');
    },

    async initializePage() {
      this.fetchSpecies();
      this.fetchListings();
    },

    // ============ API CALLS ============

    async fetchSpecies() {
      this.loadingSpecies = true;
      try {
        const response = await executeJson({ function: "getAnimalSpecies" }, flocker);
        if (response.data.success) {
          const species = response.data.data.species || [];
          this.speciesList = species.map(sp => ({
            key: String(sp.id),
            name: sp.name,
            icon: this.getSpeciesIcon(sp.name)
          }));
        }
      } catch (e) {
        console.error('Error fetching species:', e);
      } finally {
        this.loadingSpecies = false;
      }
    },

    async fetchListings(speciesFilter) {
      this.loadingListings = true;
      try {
        const params = {
          function: "searchListings",
          limit: 4,
          page: 1,
          sortBy: "newest"
        };
        if (speciesFilter && speciesFilter !== 'all') {
          params.speciesId = speciesFilter;
        }
        const response = await executeJson(params, flocker);
        if (response.data.success) {
          this.sampleListings = response.data.data.listings || [];
          // Use first 3 for phone mockup
          this.phoneListings = (response.data.data.listings || []).slice(0, 3);
        }
      } catch (e) {
        console.error('Error fetching listings:', e);
      } finally {
        this.loadingListings = false;
      }
    },

    filterBySpecies(speciesKey) {
      this.activeSpecies = speciesKey;
      this.fetchListings(speciesKey);
    },

    // ============ HELPERS ============

    formatPrice(val) {
      if (!val) return '0';
      return Number(val).toLocaleString('en-KE');
    },

    // Pilot-reviewer fix (issue #2): unit label so 280 doesn't look ambiguous
    // next to 1,000,000 — buyers can tell per-kg from per-head from per-batch.
    priceUnitLabel(u) {
      switch (u) {
        case 'per_kg_live':    return '/ kg live';
        case 'per_kg_dressed': return '/ kg dressed';
        case 'per_batch':      return '/ batch';
        case 'per_liter':
        case 'per_litre':      return '/ litre';
        case 'per_head':       return '/ head';
        // product units (per_piece, per_tray, per_kg, per_dozen, ...)
        default:               return u ? '/ ' + String(u).replace(/^per_/, '').replace(/_/g, ' ') : '';
      }
    },

    // Issue #82 — per-kg listings store the computed TOTAL in price, so show
    // the math (rate/kg × weight) instead of a misleading "/kg" suffix.
    perKgSub(item) {
      if (String((item && item.price_unit) || '').indexOf('per_kg') !== 0) return '';
      var w = Number(item.weight_kg) || 0, p = Number(item.price) || 0;
      if (w <= 0 || p <= 0) return '';
      var rate = Math.round((p / w) * 100) / 100;
      return '(' + this.formatPrice(rate) + '/kg × ' + w + ' kg)';
    },

    getInitials(name) {
      if (!name) return '?';
      var parts = name.trim().split(' ');
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name.slice(0, 2).toUpperCase();
    },

    getSpeciesIcon(speciesName) {
      if (!speciesName) return 'mdi mdi-paw';
      var s = speciesName.toLowerCase();
      if (s.includes('cattle') || s.includes('cow') || s.includes('bull') || s.includes('heifer')) return 'mdi mdi-cow';
      if (s.includes('goat')) return 'mdi mdi-alpha-g-circle';
      if (s.includes('sheep') || s.includes('ram') || s.includes('ewe') || s.includes('dorper')) return 'mdi mdi-sheep';
      if (s.includes('poultry') || s.includes('chicken') || s.includes('kienyeji') || s.includes('bird')) return 'mdi mdi-bird';
      if (s.includes('pig') || s.includes('sow') || s.includes('boar')) return 'mdi mdi-pig';
      if (s.includes('camel')) return 'mdi mdi-alpha-c-circle';
      return 'mdi mdi-paw';
    }
  }
};
</script>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
.light-mode{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}

.landing-theme-heading{color:var(--fm-h)!important}
.landing-theme-text{color:var(--fm-m)!important}
.landing-theme-muted{color:var(--fm-s)!important}
.landing-theme-disabled{color:var(--fm-s)!important;opacity:.75}
.landing-text-17{font-size:17px}
.landing-title-15{font-size:15px}
.landing-copy-14{font-size:14px;line-height:1.6}
.landing-copy-13{font-size:13px;line-height:1.6}

/* Override custom.css dark card backgrounds */
html[data-theme="light"] .landing-page-root .card,
html[data-theme="light"] .card.landing-feature-card,
html[data-theme="light"] .card.landing-step-card,
html[data-theme="light"] .card.landing-listing-card,
html[data-theme="light"] .card.landing-eco-card,
html[data-theme="light"] .card.landing-escrow-card,
html[data-theme="light"] .card.landing-pricing-card { background-color:#FFFFFF!important; background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .card-body { color:#1A1A1A!important; }

html[data-theme="dark"] .landing-feature-card .card-body,
html[data-theme="dark"] .landing-step-card .card-body,
html[data-theme="dark"] .landing-listing-card .card-body,
html[data-theme="dark"] .landing-eco-card .card-body,
html[data-theme="dark"] .landing-escrow-card .card-body,
html[data-theme="dark"] .landing-pricing-card .card-body { background:#141414!important; background-color:#141414!important; }

html[data-theme="light"] .landing-feature-card .card-body,
html[data-theme="light"] .landing-step-card .card-body,
html[data-theme="light"] .landing-listing-card .card-body,
html[data-theme="light"] .landing-eco-card .card-body,
html[data-theme="light"] .landing-escrow-card .card-body,
html[data-theme="light"] .landing-pricing-card .card-body { background:#FFFFFF!important; background-color:#FFFFFF!important; color:#1A1A1A!important; }



/* Final phone theme override */
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-mockup {
  background:#EFE8DD!important;
  border-color:#D9D0C4!important;
  box-shadow:0 28px 60px rgba(26,26,26,.10)!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-screen {
  background:#FFFFFF!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-icon {
  background:#F7F5F2!important;
  border:1px solid #E8E2DA!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-header,
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-row {
  border-bottom-color:#E8E2DA!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-title {
  color:#1A1A1A!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-meta {
  color:#777!important;
}

</style>
<style scoped>
/* === Mobile avatar pill in the landing topbar (logged in) === */
.landing-mobile-avatar { display:inline-flex; align-items:center; justify-content:center; text-decoration:none;
  border-radius:50%; padding:2px; border:1.5px solid rgba(191,161,100,.45); transition:border-color .15s, transform .15s; }
.landing-mobile-avatar:hover, .landing-mobile-avatar:active { border-color:#BFA164; transform:translateY(-1px); }

/* === Sticky bottom signup CTA — non-logged-in visitors past the hero === */
.landing-signup-cta {
  position:fixed; left:0; right:0; bottom:0; z-index:1100;
  background:linear-gradient(180deg, rgba(10,10,10,.7) 0%, rgba(10,10,10,.98) 30%, #0A0A0A 100%);
  backdrop-filter:blur(14px);
  border-top:1px solid rgba(191,161,100,.25);
  padding:14px 16px calc(14px + env(safe-area-inset-bottom, 0px));
  box-shadow:0 -8px 28px rgba(0,0,0,.35);
}
html[data-theme="light"] .landing-signup-cta {
  background:linear-gradient(180deg, rgba(255,255,255,.7) 0%, rgba(255,255,255,.98) 30%, #FFFFFF 100%);
  border-top-color:#E8E2DA;
  box-shadow:0 -8px 28px rgba(0,0,0,.08);
}
.landing-signup-cta-inner {
  max-width:1100px; margin:0 auto;
  display:flex; align-items:center; justify-content:space-between; gap:14px; flex-wrap:wrap;
}
.landing-signup-cta-msg { color:#F5F0E8; font-size:15px; flex:1; min-width:160px; }
html[data-theme="light"] .landing-signup-cta-msg { color:#1A1A1A; }
.landing-signup-cta-msg strong { color:#BFA164; font-weight:700; letter-spacing:.2px; }
.landing-signup-cta-actions { display:flex; align-items:center; gap:10px; }
.landing-signup-cta-primary {
  background:#BFA164; color:#1A1A1A; padding:10px 22px; border-radius:8px;
  font-weight:700; font-size:14px; text-decoration:none; letter-spacing:.3px;
  box-shadow:0 4px 14px rgba(191,161,100,.35); transition:transform .15s, background .15s;
}
.landing-signup-cta-primary:hover, .landing-signup-cta-primary:active {
  background:#D4B677; transform:translateY(-1px);
}
.landing-signup-cta-secondary { color:#A09888; font-size:13px; text-decoration:none; padding:6px 10px; }
html[data-theme="light"] .landing-signup-cta-secondary { color:#6B6356; }
.landing-signup-cta-secondary:hover { color:#BFA164; }
.landing-signup-cta-x {
  background:transparent; border:none; color:#A09888; font-size:18px;
  width:32px; height:32px; border-radius:50%; cursor:pointer; padding:0;
  display:flex; align-items:center; justify-content:center;
}
.landing-signup-cta-x:hover { background:rgba(255,255,255,.06); color:#F5F0E8; }
html[data-theme="light"] .landing-signup-cta-x:hover { background:rgba(0,0,0,.05); color:#1A1A1A; }
@media (max-width:480px) {
  .landing-signup-cta { padding:10px 12px calc(10px + env(safe-area-inset-bottom, 0px)); }
  .landing-signup-cta-msg { font-size:13px; min-width:0; }
  .landing-signup-cta-primary { padding:9px 16px; font-size:13px; }
  .landing-signup-cta-secondary { display:none; }
}
.landing-cta-fade-enter-active, .landing-cta-fade-leave-active { transition: transform .25s ease, opacity .25s ease; }
.landing-cta-fade-enter-from, .landing-cta-fade-leave-to { opacity:0; transform: translateY(20px); }

.landing-nav { position:fixed; top:0; left:0; right:0; z-index:1050; padding:8px 0; transition:all .3s; background:transparent; }
.landing-nav.nav-scrolled { background:rgba(10,10,10,.95); backdrop-filter:blur(20px); border-bottom:1px solid var(--fm-br); }
.landing-nav-link { color:var(--fm-m)!important; text-decoration:none; padding:8px 16px; font-size:14px; font-weight:500; }
.landing-nav-link:hover { color:#BFA164!important; }
.landing-nav-divider { width:1px; height:24px; background:var(--fm-br)!important; margin:0 12px; display:inline-block; }

.landing-user-pill { display:flex; align-items:center; gap:8px; cursor:pointer; padding:4px 10px; border-radius:20px; border:1px solid #2A2520; position:relative; transition:all 0.2s; }
.landing-user-pill:hover { border-color:#BFA164; }
.landing-avatar { width:28px; height:28px; border-radius:50%%; background:rgba(191,161,100,0.2); color:#BFA164; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:700; }
.landing-user-drop { position:absolute; top:60px; right:20px; background:var(--fm-bg1); border:1px solid var(--fm-br); border-radius:10px; padding:8px 0; min-width:180px; z-index:200; box-shadow:0 8px 30px rgba(0,0,0,0.5); }
.landing-drop-item { display:flex; align-items:center; padding:8px 16px; color:var(--fm-m); text-decoration:none; font-size:13px; transition:all 0.2s; }
.landing-drop-item:hover { background:rgba(191,161,100,0.08); color:var(--fm-h); }
.landing-mobile-menu { background:var(--fm-bg1)!important; border-top:1px solid var(--fm-br); padding:16px 24px; }
.landing-mobile-link { display:block; color:var(--fm-m)!important; text-decoration:none; padding:12px 0; border-bottom:1px solid var(--fm-br); font-size:15px; }
.landing-mobile-link:hover { color:#BFA164!important; }
.landing-hero { background:linear-gradient(135deg,#0A0A0A 0%,#1A1510 50%,#0A0A0A 100%); position:relative; overflow:hidden; }
.landing-hero::before { content:''; position:absolute; top:-50%; right:-20%; width:800px; height:800px; background:radial-gradient(circle,rgba(191,161,100,.08) 0%,transparent 70%); border-radius:50%; }
.landing-hero-title { font-size:52px; font-weight:800; line-height:1.1; color:var(--fm-h)!important; }
.landing-hero-subtitle { font-size:18px; line-height:1.7; color:var(--fm-m)!important; max-width:560px; }
.landing-stat-divider { width:1px; height:40px; background:var(--fm-br)!important; }
.landing-phone-mockup { display:inline-block; width:280px; background:#1A1A1A!important; border-radius:28px; border:2px solid #333; padding:16px; box-shadow:0 40px 80px rgba(0,0,0,.5); transition:all .3s ease; }
.landing-phone-screen { background:#111!important; border-radius:18px; padding:16px; transition:all .3s ease; }
.landing-phone-icon { width:48px; height:48px; background:#1A1A1A!important; border-radius:10px; display:flex; align-items:center; justify-content:center; flex-shrink:0; transition:all .3s ease; }
.landing-phone-header { border-bottom:1px solid var(--fm-br); }
.landing-phone-row { border-bottom:1px solid var(--fm-br); }
.landing-phone-title { font-size:13px; color:var(--fm-h)!important; }
.landing-phone-meta { font-size:11px; color:#888!important; }
.landing-feature-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:16px!important; transition:all .3s; cursor:pointer; }
.landing-feature-card .card-body, .landing-step-card .card-body, .landing-listing-card .card-body, .landing-eco-card .card-body, .landing-escrow-card .card-body, .landing-pricing-card .card-body { background:inherit!important; }
.landing-feature-card:hover { border-color:#BFA164!important; transform:translateY(-4px); box-shadow:0 12px 40px rgba(191,161,100,.1); }
.landing-feature-icon { width:52px; height:52px; border-radius:12px; display:flex; align-items:center; justify-content:center; }
.landing-feature-tag { background:rgba(191,161,100,.08); color:var(--fm-s)!important; padding:3px 10px; border-radius:50px; font-size:11px; font-weight:600; margin-right:6px; margin-bottom:4px; display:inline-block; }
.landing-step-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:16px!important; position:relative; }
.landing-step-number { position:absolute; top:-14px; left:50%; transform:translateX(-50%); width:28px; height:28px; background:#BFA164!important; color:#0A0A0A!important; border-radius:50%; font-size:13px; font-weight:800; display:flex; align-items:center; justify-content:center; }
.landing-species-tab { background:var(--fm-bg1)!important; border:1px solid var(--fm-br); color:var(--fm-m)!important; border-radius:50px; font-weight:600; }
.landing-species-tab.active, .landing-species-tab:hover { background:rgba(191,161,100,.15); border-color:#BFA164; color:#BFA164!important; }
.landing-listing-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:14px!important; overflow:hidden; transition:all .3s; }
.landing-listing-card:hover { transform:translateY(-4px); border-color:#444!important; }
.landing-listing-img { position:relative; height:180px; background:linear-gradient(135deg,var(--fm-bg1),var(--fm-bg2)); display:flex; align-items:center; justify-content:center; }
.landing-save-btn { position:absolute; top:10px; right:10px; width:32px; height:32px; background:rgba(0,0,0,.5); border:none; border-radius:50%; color:#fff!important; font-size:16px; display:flex; align-items:center; justify-content:center; cursor:pointer; }
.landing-seller-avatar { width:22px; height:22px; background:#BFA164!important; color:#0A0A0A!important; border-radius:50%; font-size:10px; font-weight:700; display:flex; align-items:center; justify-content:center; }
.landing-eco-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:16px!important; transition:all .3s; }
.landing-eco-card:hover { border-color:#BFA164!important; transform:translateY(-4px); }

/* ANITRAC × Flockr section */
.anitrac-card { background:#0F1A14; border:1px solid #1E3024; border-radius:16px; padding:0; overflow:hidden; box-shadow:0 12px 40px rgba(80,200,120,.08); }
.anitrac-card-head { display:flex; align-items:center; gap:12px; padding:18px 22px; border-bottom:1px solid #1E3024; background:rgba(80,200,120,.04); }
.anitrac-card-body { padding:22px; }
.anitrac-card-foot { padding:14px 22px; background:rgba(80,200,120,.05); border-top:1px solid #1E3024; color:#A09888; font-size:11.5px; line-height:1.5; }
.anitrac-gov { background:rgba(191,161,100,.06); border:1px solid #2A2520; border-left:4px solid #BFA164; border-radius:8px; padding:18px 22px; }
html[data-theme="light"] .anitrac-card { background:#FBFBF7 !important; border-color:#D9E3DC !important; }
html[data-theme="light"] .anitrac-card-head { background:rgba(80,200,120,.06) !important; border-color:#D9E3DC !important; }
html[data-theme="light"] .anitrac-card-foot { background:rgba(80,200,120,.04) !important; border-color:#D9E3DC !important; color:#6B6356 !important; }
html[data-theme="light"] section#anitrac { background:linear-gradient(135deg,#F4FBF7,#F7F5F2) !important; }
html[data-theme="light"] section#anitrac h2 { color:#1A1A1A !important; }
html[data-theme="light"] section#anitrac p { color:#3A3530 !important; }
html[data-theme="light"] .anitrac-card-body > div:first-child,
html[data-theme="light"] .anitrac-card-head > div > div:first-child { color:#1A1A1A !important; }
.landing-escrow-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:20px!important; }
.landing-escrow-icon { width:60px; height:60px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:24px; }
.landing-escrow-mid { width:70px!important; height:70px!important; font-size:28px!important; }
.landing-tl-dot { width:12px; height:12px; border-radius:50%; border:2px solid #2A2520; flex-shrink:0; }
.landing-tl-dot.active { background:#BFA164!important; border-color:#BFA164; }
.landing-pricing-card { background:var(--fm-bg1)!important; border:1px solid var(--fm-br)!important; border-radius:20px!important; position:relative; transition:all .3s; }
.landing-pricing-card:hover { border-color:#444!important; }
.landing-pricing-popular { border-color:#BFA164!important; }
.landing-popular-badge { position:absolute; top:-12px; left:50%; transform:translateX(-50%); background:#BFA164!important; color:#0A0A0A!important; padding:4px 16px; border-radius:50px; font-size:11px; font-weight:800; letter-spacing:1px; white-space:nowrap; }
.landing-social-icon { width:36px; height:36px; background:var(--fm-bg1)!important; border:1px solid #2A2520; border-radius:8px; display:flex; align-items:center; justify-content:center; color:var(--fm-s)!important; font-size:18px; text-decoration:none; }
.landing-social-icon:hover { border-color:#BFA164; color:#BFA164!important; }
@media(max-width:991px){ .landing-hero-title{font-size:38px} }
@media(max-width:575px){ .landing-hero-title{font-size:30px} .landing-hero-subtitle{font-size:15px} }
/* Theme Toggle */
.lp-theme-toggle {
  position:fixed; top:12px; right:16px; z-index:1060;
  width:40px; height:40px; border-radius:50%;
  background:var(--fm-bg3); border:1px solid #2A2520;
  color:#BFA164; cursor:pointer; transition:all .3s;
  display:flex; align-items:center; justify-content:center;
  box-shadow:0 2px 8px rgba(0,0,0,.4);
}
.lp-theme-toggle:hover { transform:scale(1.1); box-shadow:0 4px 12px rgba(191,161,100,.3); }
.light-mode .lp-theme-toggle { background:#FFFFFF; border-color:#E0D8D0; box-shadow:0 2px 8px rgba(0,0,0,.1); }
@media(max-width:991px){ .lp-theme-toggle{ display:none; } }
.lp-theme-toggle-mobile {
  width:38px; height:38px; border-radius:50%;
  background:var(--fm-bg3); border:1px solid #2A2520;
  color:#BFA164; cursor:pointer; transition:all .2s;
  display:flex; align-items:center; justify-content:center; flex-shrink:0;
}
.light-mode .lp-theme-toggle-mobile { background:#F7F5F2; border-color:#E0D8D0; color:#BFA164; }

/* Hide floating toggle on mobile - shown inline instead */
@media(max-width:991.98px){ .lp-theme-toggle { display:none; } }

/* Mobile theme toggle (inline with hamburger) */
.lp-theme-toggle-mobile {
  width:36px; height:36px; border-radius:50%;
  background:var(--fm-bg3); border:1px solid #2A2520;
  color:#BFA164; cursor:pointer; transition:all .3s;
  display:flex; align-items:center; justify-content:center;
  padding:0;
}
.lp-theme-toggle-mobile:hover { transform:scale(1.05); }
.light-mode .lp-theme-toggle-mobile { background:#F7F5F2; border-color:#E0D8D0; }

/* ===== LIGHT MODE OVERRIDES ===== */
.light-mode { background:#FFFFFF!important; }
.light-mode .landing-nav.nav-scrolled { background:rgba(255,255,255,.95)!important; border-bottom-color:#E8E2DA!important; }
.light-mode .landing-nav-link { color:#555!important; }
.light-mode .landing-nav-link:hover { color:#BFA164!important; }
.light-mode .landing-nav-divider { background:#E0D8D0!important; }
.light-mode .landing-user-pill { border-color:#E0D8D0; }
.light-mode .landing-user-pill span { color:#1A1A1A!important; }
.light-mode .landing-user-drop { background:#FFFFFF!important; border-color:#E8E2DA!important; box-shadow:0 8px 30px rgba(0,0,0,.12)!important; }
.light-mode .landing-drop-item { color:#555!important; }
.light-mode .landing-drop-item:hover { background:rgba(191,161,100,.08); color:#1A1A1A!important; }
.light-mode .landing-mobile-menu { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode .landing-mobile-link { color:#555!important; border-color:#E8E2DA!important; }

/* ===== COMPREHENSIVE LIGHT MODE ===== */
/* Root */
.light-mode .landing-page-root { background:#FFFFFF!important; }

/* Hero — switch to light warm bg */
.light-mode .landing-hero { background:linear-gradient(135deg,#F7F5F2 0%,#FFF8F0 50%,#F7F5F2 100%)!important; }
.light-mode .landing-hero::before { background:radial-gradient(circle,rgba(191,161,100,.06) 0%,transparent 70%)!important; }
.light-mode .landing-hero-title { color:#1A1A1A!important; }
.light-mode .landing-hero-subtitle { color:#555!important; }

/* Sections */
.light-mode section[style*="background:#0A0A0A"] { background:#FFFFFF!important; }
.light-mode section[style*="background:#0F0F0F"] { background:#F7F5F2!important; }
.light-mode section[style*="background:linear-gradient"] { background:linear-gradient(135deg,#F7F5F2,#FFFFFF)!important; border-top-color:#E8E2DA!important; }

/* CATCH-ALL text overrides — covers h2, h3, h5, h6, div, span, p, li, strong */
.light-mode [style*="color:#F5F0E8"] { color:#1A1A1A!important; }
.light-mode [style*="color:#6B6356"] { color:#777!important; }
.light-mode [style*="color:#A09888"] { color:#555!important; }
.light-mode [style*="color:var(--fm-h"] { color:#1A1A1A!important; }
.light-mode [style*="color:var(--fm-s"] { color:#777!important; }
.light-mode [style*="color:var(--fm-m"] { color:#555!important; }
/* Phone mockup accents in light mode */
.light-mode .landing-phone-screen [style*="color:#BFA164"] { color:#BFA164!important; }

/* CATCH-ALL backgrounds */
.light-mode [style*="background:#141414"],
.light-mode [style*="background:#0F0F0F"],
.light-mode [style*="background:var(--fm-bg"] { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode [style*="background:#1E1E1E"],
.light-mode [style*="background:#0A0A0A"] { background:#F7F5F2!important; }
.light-mode [style*="background:#1A1510"],
.light-mode [style*="background:#1a1510"] { background:#FFF8F0!important; border-color:#E8E2DA!important; }

/* CATCH-ALL borders */
.light-mode [style*="border-bottom:1px solid #2A2520"],
.light-mode [style*="border-bottom:1px solid #1E1E1E"],
.light-mode [style*="border-bottom:1px solid var(--fm-br"] { border-bottom-color:#E8E2DA!important; }
.light-mode [style*="border-top:1px solid #2A2520"],
.light-mode [style*="border-top:1px solid var(--fm-br"] { border-top-color:#E8E2DA!important; }
.light-mode [style*="border:1px solid #2A2520"],
.light-mode [style*="border:1px solid #1E1E1E"],
.light-mode [style*="border:1px solid var(--fm-br"] { border-color:#E8E2DA!important; }

/* Preserve accent colors */
.light-mode [style*="color:#BFA164"] { color:#BFA164!important; }
.light-mode [style*="color:#50C878"] { color:#50C878!important; }
.light-mode [style*="color:#4FC3F7"] { color:#4FC3F7!important; }
.light-mode [style*="color:#FF6B6B"] { color:#FF6B6B!important; }
.light-mode [style*="color:#FF9800"] { color:#FF9800!important; }

/* Scoped class overrides */
.light-mode .landing-stat-divider { background:#E0D8D0!important; }
.light-mode .landing-hero-subtitle { color:#555!important; }

/* Footer */
.light-mode footer { background:#F7F5F2!important; color:#555!important; border-top-color:#E8E2DA!important; }
.light-mode footer a { color:#555!important; }
.light-mode footer a:hover { color:#BFA164!important; }
.light-mode footer div[style*="border-top"] { border-top-color:#E8E2DA!important; }
.light-mode footer div[style*="color"] { color:#777!important; }
.light-mode footer p[style*="color:#F5F0E8"] { color:#1A1A1A!important; }
.light-mode footer p[style*="color:#A09888"] { color:#555!important; }
.light-mode footer [style*="border-top:1px solid #2A2520"] { border-top-color:#E8E2DA!important; }

/* Feature cards */
.light-mode .landing-feature-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode .landing-feature-card:hover { box-shadow:0 12px 40px rgba(191,161,100,.08)!important; }
.light-mode .landing-feature-tag { background:rgba(191,161,100,.1)!important; color:#8B7355!important; }

/* Step cards */
.light-mode .landing-step-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }

/* Species tabs */
.light-mode .landing-species-tab { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#555!important; }

/* Listing cards */
.light-mode .landing-listing-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode .landing-listing-card:hover { border-color:#BFA164!important; }
.light-mode .landing-listing-img { background:linear-gradient(135deg,#F0EBE4,#E8E2DA)!important; }

/* Ecosystem cards */
.light-mode .landing-eco-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode .landing-eco-card:hover { border-color:#BFA164!important; }

/* Pricing cards */
.light-mode .landing-pricing-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
.light-mode .landing-pricing-popular { border-color:#BFA164!important; }

/* Phone mockup - light theme */
.light-mode .landing-phone-mockup { background:#EFE8DD!important; border-color:#D9D0C4!important; box-shadow:0 28px 60px rgba(26,26,26,.10)!important; }
.light-mode .landing-phone-screen { background:#FFFFFF!important; }
.light-mode .landing-phone-icon { background:#F7F5F2!important; border:1px solid #E8E2DA!important; }
.light-mode .landing-phone-header,
.light-mode .landing-phone-row { border-bottom-color:#E8E2DA!important; }
.light-mode .landing-phone-title { color:#1A1A1A!important; }
.light-mode .landing-phone-meta { color:#777!important; }

/* Drop item hover */
.light-mode .landing-drop-item:hover { color:#1A1A1A!important; }

/* Hero title - keep light on dark hero */
/* .landing-hero stays dark in both themes */

/* Escrow card */
.light-mode .landing-escrow-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }

/* Force Bootstrap .card backgrounds to follow theme */
.light-mode .card { background-color:var(--fm-bg1)!important; border-color:var(--fm-br)!important; }

/* Final hard override for card surfaces across light theme */
.landing-page-root.light-mode .landing-feature-card,
.landing-page-root.light-mode .landing-step-card,
.landing-page-root.light-mode .landing-listing-card,
.landing-page-root.light-mode .landing-eco-card,
.landing-page-root.light-mode .landing-escrow-card,
.landing-page-root.light-mode .landing-pricing-card {
  background:#FFFFFF !important;
  background-color:#FFFFFF !important;
  border:1px solid #E8E2DA !important;
  box-shadow:none;
}

.landing-page-root.light-mode .landing-feature-card .card-body,
.landing-page-root.light-mode .landing-step-card .card-body,
.landing-page-root.light-mode .landing-listing-card .card-body,
.landing-page-root.light-mode .landing-eco-card .card-body,
.landing-page-root.light-mode .landing-escrow-card .card-body,
.landing-page-root.light-mode .landing-pricing-card .card-body {
  color:#1A1A1A !important;
}

.landing-page-root.light-mode .landing-feature-card h5,
.landing-page-root.light-mode .landing-step-card h6,
.landing-page-root.light-mode .landing-listing-card h6,
.landing-page-root.light-mode .landing-eco-card h5,
.landing-page-root.light-mode .landing-pricing-card .landing-theme-heading {
  color:#1A1A1A !important;
}


/* Final phone theme override */
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-mockup {
  background:#EFE8DD!important;
  border-color:#D9D0C4!important;
  box-shadow:0 28px 60px rgba(26,26,26,.10)!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-screen {
  background:#FFFFFF!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-icon {
  background:#F7F5F2!important;
  border:1px solid #E8E2DA!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-header,
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-row {
  border-bottom-color:#E8E2DA!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-title {
  color:#1A1A1A!important;
}
html[data-theme="light"] .landing-page-root.light-mode .landing-phone-meta {
  color:#777!important;
}

</style>